function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpSkilling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 380,
    height: 363.134,
    viewBox: "0 0 380 363.134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "6co66nbbka"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 270",
    style: {
      fill: "none"
    },
    d: "M0 0h380v363.132H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "jujzg3snxb"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2103",
    d: "m356.925 182.193 13.214.121-5.436-12.77-13.213-.121z",
    transform: "translate(-351.49 -169.423)",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ql52paxz9c"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2105",
    d: "m220.346 273.522-5.782 15.212 11.76-.458 5.782-15.212z",
    transform: "translate(-214.564 -273.064)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1902",
    d: "m363.668 453.548 1.465-32.711 1.618-30.471-8.811-24.183-12.41 26.572v33.734l-.635 25.362z",
    transform: "translate(-125.735 -133.494)",
    style: {
      fill: "#1f1f1d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1903",
    d: "m114.092 373.39-9.362 1.9-16.3 12.284-4.748 19.026-4.788 46.429 2.542 38.762 2.542 5.719 71.586.931 32.677-.106 19.648-3.367.943-67.6-2.872-15.148-14.592-34.811-44.736-4.278-19.736-1.978z",
    transform: "translate(-28.762 -135.307)",
    style: {
      fill: "#1f1f1d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2197"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2196",
    style: {
      clipPath: "url(#6co66nbbka)"
    },
    transform: "translate(0 .002)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1904",
    d: "M276.949 7.08c0 .138.012.275.025.412l-10.223.208-.09-.62z",
    transform: "translate(-97.214 -2.581)",
    style: {
      fill: "#bec1c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1905",
    d: "M343.561 400.175c-.355-1.5-1.328-1.3-2.215-1.316-4.078-.05-8.159-.213-12.234-.115-1.782.043-2.351-.543-2.072-2.195a1.492 1.492 0 0 0 0-.244q-.082-49.961-.14-99.921c0-6.6.149-13.212.51-19.8.372-6.791 2.818-8.927 9.507-8.927h80.1c11.756.005 23.513.088 35.269.039 1.72-.007 2.246.449 2.169 2.174-.139 3.1.084 6.21-.086 9.3-.1 1.851.472 2.34 2.282 2.317 10.283-.13 20.569-.1 30.852-.24 1.888-.026 2.4.379 2.327 2.378-.677 19.171-.506 38.352-.452 57.53.065 22.852.158 45.7.46 68.553.083 6.265-3.307 8.8-8.91 9.269-3 .25-6.028.275-9.043.277q-35.272.031-70.544 0c-18.446-.032-36.891-.179-55.337-.186-1.791 0-2.555-.363-2.249-2.239a7.913 7.913 0 0 0-.066-2.195c-.143-1.165.285-1.526 1.477-1.523 2.606.008 5.212-.189 7.82-.248 1.2-.027 1.59-.463 1.612-1.739.091-5.367.146-5.366-5.07-5.328-3.937.029-3.977.022-3.342-3.842q3.743-22.79 7.531-45.574c.24-1.452.338-2.9 2.589-2.149 1.4.468 1.772-.216 1.247-1.677a385.58 385.58 0 0 1-4.433-13.171c-.51-1.6-1.1-1.483-2.139-.483-3.555 3.409-4.3 9.774-.59 12.891 1.263 1.062.7 2.223.517 3.357-2.408 14.879-4.848 29.755-7.344 45.02",
    transform: "translate(-119.175 -97.575)",
    style: {
      fill: "#aec0ca"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1906",
    d: "M203.869 151.656c0 18.775-.028 37.549.017 56.324.013 5.54.265 11.076 0 16.619-.3 6.33-3.482 9.578-9.853 9.668-6.855.1-13.712.077-20.569.1-11.1.032-22.2.029-33.3.084-24.156.121-48.311.233-72.466.469-2.216.022-2.8-.624-2.658-2.661.109-1.537-.137-3.1-.1-4.641.037-1.528-.458-2.1-2.116-2.11-9.706-.053-19.411-.309-29.117-.311-2.126 0-2.665-.476-2.661-2.647q.11-63.793.062-127.586c0-3.506.1-7.013.158-10.52.107-6.454 3.418-9.762 9.879-9.773q35.264-.061 70.528-.088 23.625-.045 47.249-.163c6.365-.028 12.73-.041 19.092-.2 1.781-.045 2.661.35 2.256 2.237-.574 2.677.844 3.113 3.1 3.062 6.361-.143 12.727-.111 19.089-.238 1.132-.022 1.483.057 1.48 1.364q-.084 35.508-.041 71.016z",
    transform: "translate(-11.318 -27.055)",
    style: {
      fill: "#aec0ca"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1907",
    d: "M397.409 24.039q27.787 0 55.575.022a27.9 27.9 0 0 1 4.856.507c4.333.782 6.66 3.5 6.78 7.926.113 4.159.16 8.32.168 12.481q.1 48.963.212 97.925c.007 1.968-.391 2.688-2.509 2.6-4.969-.213-9.951-.111-14.925-.243-1.775-.048-2.392.538-2.439 2.366-.125 4.871-.213 4.894-5.216 4.841-34.921-.37-69.842-.652-104.765-.655-7.328 0-7.333-.047-7.356-7.274q-.128-40.517-.3-81.034c-.012-2.063.342-2.914 2.609-2.692s4.571-.132 6.844.013c1.91.122 2.542-.417 2.478-2.42-.3-9.209-.443-18.423-.641-27.636a230.23 230.23 0 0 1-.052-3.426c-.021-3.218-.018-3.218 3.335-3.218h55.341z",
    transform: "translate(-119.391 -8.763)",
    style: {
      fill: "#aec0ca"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1908",
    d: "M141.159 402.5c.827 2.174 1.933 3.575 4.015 3.844.569.074 1.27.242 1.549-.333.312-.64-.374-1.048-.815-1.3-1.865-1.067-3.112-2.389-2.211-4.831 1.5 1.393 3.133 2.76 5.493 1.889.472-.175 1.05-.338 1.064-.852.02-.684-.673-.517-1.115-.62-3.088-.718-4.6-2.642-5-6.982 2.218 3.084 4.867 2.891 7.627 2.167.359-.095.888.146 1.024-.365.154-.583-.344-.9-.757-1.122a2.714 2.714 0 0 0-2.328-.487c-2.059.9-2.988-.159-3.7-1.87-.606-1.463-2.036-2.266-3.063-3.455a2.271 2.271 0 0 1 2.514.7c1.5 1.232 3.539.109 5.127 1.156.257.17.431-.54.335-.947a1.85 1.85 0 0 0-1.9-1.573 5 5 0 0 1-4.343-2.655c-1.716-2.653-4.552-2.851-7.531-2.824.893-1.317 2.081-.911 3.126-.82a5.233 5.233 0 0 0 4.824-1.771.985.985 0 0 0 .254-1.12c-.243-.469-.628-.348-1.033-.172-2.929 1.271-5.878.9-8.859.158-1.65-.412-3.353-.05-5.315.068a14.857 14.857 0 0 1 3.992-3.419c.392-.281.934-.508.741-1.082-.177-.527-.742-.574-1.241-.586a5.009 5.009 0 0 0-3.543 1.366 17.78 17.78 0 0 1-4.8 3.335c-1.023.424-2.518 1.726-3.159.506a4.054 4.054 0 0 1 .387-4.377c.294-.351.881-.477.839-1.087-2.532-.988-3.894-.132-3.906 2.448a4.6 4.6 0 0 1-.353 2.385c-.449.8-.951 1.4-1.911.818a1.291 1.291 0 0 1-.384-2.077c.515-.7 1.543-1.472.28-2.15-1.333-.715-1.853.409-2.163 1.512-.666 2.364-2.954 3.931-3.187 6.515-.055.61-.545.749-1.08.715-.5-.032-.6-.384-.736-.805-.189-.588.506-1.761-.7-1.668-.987.076-1.265 1.176-1.455 2.045a1.931 1.931 0 0 0 .135 1.421c1.707 2.124.138 2.877-1.4 3.849a10.211 10.211 0 0 0-4.207 4.282c2.651.931 4.2-2.168 6.917-1.292-2.08 1.546-4.184 2.8-5.373 4.96-.372.674-1.19 1.542-.482 2.164.836.734 1.61-.136 2.265-.761a2.527 2.527 0 0 1 2.44-1.119c-2.536 2.774-1.32 6.435-2.92 9.352-.245.446-.492.928.034 1.3.482.338.933-.032 1.356-.257 1.514-.807 1.947-1.859 2.5-5.687 1.1 3.208-.725 8.495 5.919 7.908-1.908 2.7-2.633 5.288-6.349 6.318-8.845 2.453-14.444 9.082-18.549 17-4.181 8.065-5.905 16.853-7.332 25.714-.375 2.331-.7 4.672-1.035 7.01a8.657 8.657 0 0 0 1.651 6.923 2.059 2.059 0 0 1 .159 2.422 38.861 38.861 0 0 0-2.409 7.658c-1.3 6.344-.549 9.915 3.2 14.8-6.837.566-9.877-2.111-9.968-8.851q-.128-9.545-.165-19.091l-.281-86.927c-.008-1.744.117-2.526 2.307-2.311 5.312.521 5.328.366 5.153-4.991-.163-5-.163-5.117 4.709-5.119q37.712-.022 75.423.078c13.381.038 26.762.205 40.142.318 1.143.01 2.289-.011 3.425.082a5.835 5.835 0 0 1 5.688 5.578c.672 7.074.4 14.177.549 21.266.254 12.4.194 24.807.325 37.211.014 1.306-.372 1.665-1.637 1.611a71.564 71.564 0 0 0-6.855.005c-1.354.07-1.634-.444-1.6-1.664.113-3.666.065-7.337.218-11a1.926 1.926 0 0 0-1.762-2.332 146.78 146.78 0 0 1-9.208-2.423c-1.306-.393-1.585.1-1.684 1.194a19.012 19.012 0 0 1-.408 2.9c-.311 1.248 0 2.112 1.284 2.389 4.513.976 5.819 3.851 5.077 8.142-.246 1.422.444 3.161-2.184 2.829-1.23-.156-.834 1.172-.85 1.882-.168 7.58-.344 15.161-.391 22.742-.01 1.63-.315 2.472-2.111 2.182-.557-.09-1.153.061-1.71-.027-2.8-.441-4.89.269-5.718 3.285a1.7 1.7 0 0 1-2.01 1.323c-1.3-.108-2.61-.041-3.916-.02-.859.014-1.631.063-1.571-1.2.048-1.005-.132-2.014 1.376-1.984.482.01.975-.243 1.449-.2 2.743.232 1.951-1.8 1.88-3.119-.1-1.91-1.682-.912-2.37-.72-2.525.706-4.265.134-5.743-2.139a21.636 21.636 0 0 0-3.892-4.022c-1.955-1.751-3.822-1.745-6.652.22-1.36.944-2.265.745-3.8.244-5.054-1.65-9.935-4.1-15.382-4.26a3.812 3.812 0 0 1-3.815-2.39c-2.455-5.451-5.862-10.53-6.082-16.829a7.131 7.131 0 0 0-2.422-5.44c-.543-.45-.9-.909-.594-1.672.4-.982 1.05-.4 1.636-.328a10.874 10.874 0 0 0 5.783-.393 3.536 3.536 0 0 0 2.307-3.66c-.119-2.7.122-5.245 2.5-7.058a1.377 1.377 0 0 0 .345-1.77c-1.017-2.467-.408-4.908.078-7.774",
    transform: "translate(-26.931 -134.683)",
    style: {
      fill: "#aec0ca"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1909",
    d: "M122.392 460.47c-1.366 6.845-2.685 13.7-4.126 20.529-.414 1.964.838 1.594 1.816 1.5a42.428 42.428 0 0 1 12.593 1c1.613.332 2.586.8 1.8 2.649-.155.365-.128.8-.25 1.186-.427 1.342.779 3.142-.684 4.065-2.033 1.284-4.155 2.5-6.748 2.509-4.721.025-9.44.2-14.16.305-8.355.192-14.282-6.342-13.568-14.737.743-8.733 3.954-16.7 7.268-24.657.311-2.1 1.862-3.463 2.875-4.888-1.3 1.09-1.856 3.074-3.474 4.189-4.457 7.291-6.291 15.435-7.845 23.7-1.376 7.316.663 12.551 9.3 17.086 1.452.763 1.137 1.834 1.045 2.846-.146 1.607.486 2.157 2.017 2.194 4.973.12 9.943.4 14.916.432 1.905.011 3.008.231 2.4 2.493-.405 1.5.832 3.5-.708 4.565a13.123 13.123 0 0 1-10.417 2.366c-4.327-.887-8.36-2.69-12.58-3.9-1.564-.447-3.13-.918-4.725-1.218-7.632-1.433-11.486-7.013-10.247-14.676 1.366-8.441 2.446-16.953 5.62-24.965 3.759-9.49 9.609-17.116 19.38-21.2 4.718-1.974 7.785 1.172 11.153 3.291 1.339.843 2.286 2.3 3.432 3.461a4.164 4.164 0 0 0 2.473 1.491c3.013.181 4.005 2.249 4.395 4.681a81.6 81.6 0 0 1 .536 20.953c-.157 1.591.367 3.769-.844 4.643-1.191.86-3.032-.473-4.615-.7a36 36 0 0 0-8.774-.545c-1.958.206-1.909-.667-1.632-2.047 1.139-5.671 2.085-11.373 2.756-17.119-.309-.45.173-1.1-.377-1.488",
    transform: "translate(-32.322 -161.58)",
    style: {
      fill: "#dea4b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1910",
    d: "M31.309 358.576c-7.259 0-14.517-.036-21.775.032-1.336.013-1.852-.222-1.841-1.7q.16-20.55.17-41.1c0-1.361.365-1.826 1.785-1.811q21.891.234 43.783.334c1.317.006 1.647.508 1.668 1.733q.271 15.644.637 31.288c.062 2.767.08 5.547.365 8.3.218 2.1-.623 2.668-2.535 2.644-4.894-.064-9.789-.018-14.683-.018H31.31v.3",
    transform: "translate(-2.805 -114.471)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1911",
    d: "M553.347 285.908v.33c-7.5 0-15.005-.038-22.507.038-1.239.013-1.464-.292-1.452-1.469",
    transform: "translate(-192.993 -103.829)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1912",
    d: "M514.727 219.52c0-1.847.377-2.453 2.361-2.432",
    transform: "translate(-187.648 -79.141)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1913",
    d: "M291.895 54.642c-7.34 0-14.681-.055-22.02.044-1.559.022-1.855-.419-1.846-1.88q.123-20.446.083-40.894c0-1.311.235-1.814 1.7-1.8q21.912.207 43.826.25c1.378 0 1.536.531 1.561 1.7.2 9.373.461 18.746.706 28.119.1 4 .142 7.994.356 11.983.088 1.656-.285 2.221-2.077 2.194-7.428-.109-14.858-.046-22.287-.046v.329",
    transform: "translate(-97.712 -3.686)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1914",
    d: "M285.159 520.284c-7.415 0-14.83-.036-22.244.034-1.279.012-1.831-.074-1.818-1.6.115-13.535.184-27.071.137-40.606-.007-1.971.562-2.382 2.427-2.367 13.781.105 37.155.112 50.937.111 2.132 0 3.379.121 3.41 3.053.142 13.187.627 26.371 1.059 39.554.051 1.578-.805 1.421-1.81 1.42-7.5-.012-24.6-.006-32.1-.006v.408",
    transform: "translate(-95.186 -173.437)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1915",
    d: "M190.646 561.191a9.6 9.6 0 0 0-6.247-11.839c-3.9-1.376-7.967-2.283-11.947-3.442a5.591 5.591 0 0 1-2.936-1.37c18.615 0 37.027 0 55.439.007.46 0 1.254-.178 1.3.308.256 2.744 2.434 1.7 3.718 1.738 4.64.128 9.291.047 13.932-.134 1.82-.071 2.543.4 2.3 2.279-.2 1.529-.116 3.093-.278 4.628-.544 5.19-3.331 8.033-8.571 8.193-5.945.181-11.9.015-17.853-.044-8.883-.088-17.766-.214-26.65-.322-.722-.009-1.444 0-2.211 0",
    transform: "translate(-61.799 -198.508)",
    style: {
      fill: "#37353b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1916",
    d: "M165.249 528.811c-13.874 0-27.748-.018-41.623.027-1.475.005-2.131-.21-2.148-1.945-.018-1.828.932-1.677 2.13-1.683q30.486-.142 60.974-.318c7.426-.042 14.857.015 22.275-.222 3-.1 1.828 1.849 2.059 3.2.292 1.713-.564 1.974-2.068 1.941q-14.682-.326-29.365-.5c-4.077-.056-8.157-.009-12.235-.009v-.49",
    transform: "translate(-44.286 -191.273)",
    style: {
      fill: "#fdfdfe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1917",
    d: "M189.727 539.037c-10.038 0-20.077-.033-30.115.034-1.6.01-2.484-.24-2.218-2.076a6.176 6.176 0 0 0-.173-1.943c-.2-1.085-.007-1.6 1.312-1.588 11.67.138 23.34.189 35.011.308 8.811.09 17.622.317 26.433.334 3.491.006 1.526 2.471 1.9 3.813.5 1.8-.837 1.585-2.034 1.582-10.037-.032-20.075-.018-30.112-.018v-.446",
    transform: "translate(-57.292 -194.479)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1918",
    d: "M168.25 425.864c-4.885-.817-8.047 1.034-10.025 4.918-.56 1.1-.985.919-1.841.458a8.783 8.783 0 0 1-4.568-9.663 26.247 26.247 0 0 1 3.439-9.085 5.54 5.54 0 0 1 5.818-2.73c3.137.373 5.838 1.666 7.394 4.519.377.692-.089 1.891-.28 2.835-.566 2.8-1.37 5.575.063 8.749",
    transform: "translate(-55.29 -149.362)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1919",
    d: "M165.07 479.056c1.775 3.579 3.245 6.459 4.634 9.379a3.87 3.87 0 0 0 3.554 2.464 36.546 36.546 0 0 1 10.909 2.465c1.245.494 1.66 1.077 1.317 2.342-.168.62-.078 1.305-.214 1.937-.166.771.6 2.046-.676 2.217-1.294.174-2.752.426-3.889-.746-3.569-3.679-5.825-4.233-10.613-2.134-2.311 1.013-3.785-1.328-5.826-.963a6.135 6.135 0 0 1-.074-1.195 124.437 124.437 0 0 0 .878-15.766",
    transform: "translate(-59.853 -174.644)",
    style: {
      fill: "#dea4b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1920",
    d: "M220.485 508.517a16.188 16.188 0 0 1-11.7-.342c-.578-.233-1.634-.087-1.425-1.245.162-.9-.23-1.822.792-2.628 4.1-3.229 5.657-3.184 9.248.662 1.041 1.115 2 2.3 3.083 3.553",
    transform: "translate(-75.586 -182.999)",
    style: {
      fill: "#fdfdfe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1921",
    d: "M175.344 512.833a4.287 4.287 0 0 1 .176.417c-.888.481-4.262-.134-4.584-.818-.714-1.52.154-3.2 2.033-3.935 5.443-2.124 8.942-.614 10.714 4.815-1.35-.576-2.145-2.078-3.55-1.925-1.357.147-2.394-.62-3.685-.768l1.387 1.832c-.812.7-1.288-.179-1.889-.155-.447-.1-.83-.122-.6.537",
    transform: "translate(-62.226 -185.041)",
    style: {
      fill: "#fbfbfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1922",
    d: "M144.226 426.947c-4.26-1.61-4.242-1.6-2.226-5.185a26.724 26.724 0 0 0 1.286-2.868c.37-.891.789-1.642-.618-2.273-1.153-.517-.93-1.777-.322-2.766s1.59-.808 2.393-.463c.965.414 1.782.944 1.312 2.406a39.571 39.571 0 0 0-1.824 11.149",
    transform: "translate(-51.288 -150.607)",
    style: {
      fill: "#fafafc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1923",
    d: "M194.673 520.944c6.778-.712 13.559-1.4 20.332-2.157 1.023-.114 1.5 0 1.437 1.172-.048.9-.014 1.507-1.252 1.5-6.837-.056-13.675-.027-20.513-.027v-.485",
    transform: "translate(-70.97 -189.116)",
    style: {
      fill: "#fbfbfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1924",
    d: "M171.3 518.923c-1.089 3.016-3.649 2.108-5.822 2.147-2.671.048-5.344.012-8.511.012 1.706-1.322 2.99-2.082 4.856-1.866 1.38.161 2.947.309 4.043-1.078.515-.652 1.273-.221 1.819-.023a7.82 7.82 0 0 0 3.6.323.3.3 0 0 1 .121.32c-.034.11-.069.165-.106.165",
    transform: "translate(-57.223 -188.766)",
    style: {
      fill: "#f9fafb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1925",
    d: "M166.629 511.681c-.116 1.172.564 2.891-1.6 2.765-.938-.054-2.589 1-2.7-.906-.1-1.749-.6-3.893 1.407-5 1.76-.974 2.889.316 2.888 3.144",
    transform: "translate(-59.133 -185.274)",
    style: {
      fill: "#dea4b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1926",
    d: "M143.557 439.947c-.849-1.075-.918.04-1.254.44-.3.354-.2 1.2-1.137.749s-.438-.97-.256-1.569c.2-.654.875-1.181.6-1.988-.941-.13-.943.749-1.311 1.185-.392.465-.445 1.211-1.331 1.478-.551-1.333.583-2.206.837-3.257.231-.953.026-1.05-.715-.5-.433.051-.707-.029-.451-.547a3.265 3.265 0 0 1 5.028 1.27c.3.9.534 1.826.8 2.74a.509.509 0 0 1-.81 0",
    transform: "translate(-50.47 -158.661)",
    style: {
      fill: "#dea4b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1927",
    d: "M199.67 506.382c.412-.644-1.031-2.614 1.082-2.707 1.478-.065 2.952.748 2.639 2.7-.187 1.174.516 2.995-1.747 3.032-1.893.032-2.343-1.036-1.973-3.029",
    transform: "translate(-72.748 -183.618)",
    style: {
      fill: "#dea4b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1928",
    d: "M146.083 442.662h.81a13.039 13.039 0 0 0 5.635 5.907 1.24 1.24 0 0 1 .71 1.784c-.5 1.217-1.3.353-1.792.083-2.489-1.361-3.734-4.029-5.881-5.79-.548-.449.2-1.341.519-1.984",
    transform: "translate(-52.996 -161.376)",
    style: {
      fill: "#dea4b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1929",
    d: "M191.834 513.367c4.439.7 8.49.335 12.523.407l.013.623c-3.4.515-6.8.992-10.192 1.561-1.782.3-1.65-1.072-2.345-2.59",
    transform: "translate(-69.935 -187.153)",
    style: {
      fill: "#eeeff2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1930",
    d: "M151.726 536.232c-.027-.562-.05-1.125-.082-1.688-.037-.643.118-1.064.9-1.073.729-.008 1.247.092 1.3.977.074 1.2.17 2.4.329 3.6.144 1.072-.326 1.359-1.328 1.464-1.233.129-1.033-.675-1.073-1.347-.037-.642-.008-1.287-.008-1.93h-.039",
    transform: "translate(-55.281 -194.482)",
    style: {
      fill: "#f4f4f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1931",
    d: "M179.5 518.073a1.054 1.054 0 0 1-.015-.485c3.944-2.773 3.944-2.773 6.293-.362l-6.278.847",
    transform: "translate(-65.425 -187.916)",
    style: {
      fill: "#e2e4e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1932",
    d: "M170.981 442.986c-.255.984-1.069 1.379-1.879 1.77-.525.254-1.2.491-1.6.079-.6-.608-.135-1.369.086-2.053.32-.993.91-.273 1.355-.177a2.776 2.776 0 0 0 1.672-.135.665.665 0 0 1 .369.515",
    transform: "translate(-60.956 -161.231)",
    style: {
      fill: "#e3e5ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1933",
    d: "M115.53 457.132a11.878 11.878 0 0 1 5.112-5.666l-4.514 6.365-.6-.7",
    transform: "translate(-42.118 -164.586)",
    style: {
      fill: "#202221"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1934",
    d: "m171.853 441.654-.369-.515c-.318-.857-1.5-.5-1.887-1.354a1.878 1.878 0 0 1 2.617-.921c.972.732.079 1.875-.36 2.789",
    transform: "translate(-61.828 -159.9)",
    style: {
      fill: "#edeef2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1935",
    d: "M141.745 469.821c.04-.307-.024-.786.141-.884.33-.2.566.073.517.462-.08.639-.186 1.273-.282 1.91-.454-.413-.348-.968-.377-1.488",
    transform: "translate(-51.674 -170.931)",
    style: {
      fill: "#1f1f1d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1936",
    d: "m138.068 436.352.451.547c-.274.6-.376 1.36-1.371 1.453a2.429 2.429 0 0 1 .919-2",
    transform: "translate(-49.998 -159.076)",
    style: {
      fill: "#cbcdd5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1937",
    d: "M177.426 515.073c-.52-.258-1.426-.5-.835-1.2.39-.46 1.046.2 1.437.663l-.6.537",
    transform: "translate(-64.307 -187.28)",
    style: {
      fill: "#373b3a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1938",
    d: "M462.8 409.775a51.29 51.29 0 0 1 15.8-22.7 9.75 9.75 0 0 0 2.452 6.138 1.5 1.5 0 0 0 1.094.632 1.618 1.618 0 0 0 1.054-.727l6.667-8.044c1.582-1.908 2.786-6.132 5.007-7.232 2.41-1.193 1.121-.532 3.715.173s9.554 3.663 11.739 5.23c4.666 3.346 8.888 7.9 9.935 13.549.255 1.375.316 2.788.7 4.134.657 2.319 2.215 4.275 3.1 6.514 1.017 2.563 1.12 5.391 1.833 8.055.509 1.9 1.329 3.72 1.742 5.648a27.684 27.684 0 0 1 .351 6.485l-.489 19.954c-2.556-.136-4.733 1.4-7.29 1.259-3.035-.162-6.2-.892-9.238-.774-10.289.4-20.767 2.892-30.943 1.322a8.116 8.116 0 0 1-4.89-2.11c-1.333-1.456-1.594-3.571-1.737-5.538-.362-4.989-1.695-10.862-1.344-15.851.207-2.935-1.136-5.326-1.688-8.216s.113-2.255-2.552-3.5",
    transform: "translate(-168.717 -137.505)",
    style: {
      fill: "#dc5b1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1939",
    d: "M441.378 384.822a149.878 149.878 0 0 0-.493 20.777c.049 1-.071 1.492-1.32 1.285-3.617-.6-7.249-1.132-10.892-1.547-1.772-.2-1.095-1.346-.95-2.142a66.593 66.593 0 0 1 3.794-13.347c.4-.987.908-1.9-.091-2.888-.812-.8-.253-1.7.108-2.5 1.2-2.655 2.452-5.289 3.693-7.952-7.907-1.268-11.452-8.284-7.174-15.27 2.753-4.5 2.76-9.248 3.372-14.042a2.2 2.2 0 0 0-.849-1.881c-3.238-3.458-3.332-7.5-.339-11.137-4.411-2.51-4.332-6.795-3.909-10.907.419-4.067 2.829-6.767 7-7.806 3.07-.765 6.266-1.4 9.143-.2 4.017 1.688 8.2 1.755 12.349 2.229 12.058 1.379 16.911 10.207 17.243 19.926.094 2.77.87 4.36 3.275 5.387 2.014.86 4 1.795 6 2.688a28.736 28.736 0 0 1 14.988 14.744c2.888 6.389 1.457 11.92-4.061 16.257a1.73 1.73 0 0 0-.736 2.23 116.136 116.136 0 0 1 4.853 24.146 102.834 102.834 0 0 1 .257 18.564c-.222 2.417.23 3.712 2.962 3.206a1.427 1.427 0 0 1 1.6.6c-1.889.193-3.565.451-5.249.52q-13.076.538-26.155.991a9.555 9.555 0 0 0-3.562.675 12.489 12.489 0 0 1-7.7.724c-5.68-1.251-11.369-.7-17.058-.56-10.759.269-21.515.63-32.272.961q-15.156.468-30.312.96c-1.11.036-2.353.17-1.969-1.5.313-1.361-1.355-3.712 1.707-3.837 4.725-.193 9.451-.4 14.178-.5 1.347-.027 2-.056 1.788-1.8a6.653 6.653 0 0 1 2.488-6.289 62.75 62.75 0 0 0 5.849-5.192c3.634-3.786 8.1-3.819 12.885-3.552 11.758.656 23.377 2.718 35.14 3.279 1.411.067 2.144-.133 2.435-1.733a143.356 143.356 0 0 1 3.9-15.87c.357-1.179.271-1.987-.907-2.624a2.5 2.5 0 0 1-1.313-2.9c1.425-6.935 3-13.834 5.017-20.624.031-.1.254-.149.809-.452-.595 2.9-1.146 5.5-1.659 8.1-.818 4.154-1.557 8.325-2.446 12.463a1.973 1.973 0 0 0 .917 2.436c7.642 5.172 16.109 6.744 25.153 5.9 1.325-.124 2.3-.472 2.162-2.176a16.348 16.348 0 0 1 .414-3.276c1.64 2.952.82 5.812-1.959 6.841-1.041.386-1.02 1.09-1.154 1.871a74.194 74.194 0 0 1-5.848 19.827 18.5 18.5 0 0 1-5.781 7.255c3.14.451 6.026.1 8.891.086 4.481-.024 8.964-.386 13.441-.31 2.093.036 2.551-.7 2.608-2.586a156.972 156.972 0 0 0-2.807-33.552 50.379 50.379 0 0 0-14.377-26.9 18.678 18.678 0 0 0-12.6-5.722 2.836 2.836 0 0 0-2.8 1.371 151.4 151.4 0 0 1-11.205 13.573c-1.127 1.242-1.667 1.093-2.51-.129a19.7 19.7 0 0 1-2.786-6.066c-5.964 5.9-10.9 12.364-13.851 20.2a1.613 1.613 0 0 0-.175.7c.13 1.06 6.037 4.48 7.008 3.99.314-.158.461-.79.545-1.231.3-1.6.548-3.215.815-4.825.925.011.613.582.483 1.069",
    transform: "translate(-137.345 -114.69)",
    style: {
      fill: "#1f1f1d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1940",
    d: "M387.388 399.089c.06.78-.43.84-.888 1.053-4.505 2.093-4.54 2.118-6.19-2.584q-14.274-40.7-28.477-81.43c-.308-.885-1.629-2.518.678-2.683 1.522-.109 3.412-2.554 4.608.827q14.874 42.05 29.925 84.036c.109.305.26.594.343.782",
    transform: "translate(-128.025 -113.92)",
    style: {
      fill: "#1f1f1d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1941",
    d: "M374.727 303.907c-7.815-.15-8.5-.895-8.685-8.474-.1-4.236-.5-8.465-.612-12.7-.117-4.506 1.721-6.542 6.179-6.692 15.41-.518 30.825-.6 46.238-.148 2.959.086 4.78 1.983 5.06 5.207a129.067 129.067 0 0 1 .085 16.87c-.154 3.475-2.523 5.481-6.211 5.486-10.613.013-21.227.121-31.836-.069-3.008-.054-5.089 1.258-7.234 2.924-1.189.923-2.582 2.807-3.789 2.126-1.282-.723.831-2.314.669-3.688a3.511 3.511 0 0 1 .137-.841",
    transform: "translate(-133.219 -100.471)",
    style: {
      fill: "#1b1c19"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1942",
    d: "M523.381 387.185c3.1 4.538 3.655 9.694 3.447 14.966a54.043 54.043 0 0 1-2.624 14.388c-.133.414-.064 1.025-1.116 1.279 2.285-10.124 4.128-20.142-.174-30.038-.26-.524.072-.583.466-.595",
    transform: "translate(-190.6 -141.152)",
    style: {
      fill: "#1b1c1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1943",
    d: "M535.456 415.724c.853-8.948.622-17.8-2.384-26.412 4.671 8.96 5.093 18.342 2.876 27.991-1.133-.224-.509-1-.492-1.578",
    transform: "translate(-194.336 -141.927)",
    style: {
      fill: "#1b1c19"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1944",
    d: "m478.182 422.2-.483-1.069.494-4c.989 1.745.444 3.407-.011 5.071",
    transform: "translate(-174.15 -152.068)",
    style: {
      fill: "#343736"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1945",
    d: "M536.266 430.877c.259.5-.123 1.193.492 1.578-.217.877-.16 1.859-1.464 2.441l.971-4.02",
    transform: "translate(-195.147 -157.08)",
    style: {
      fill: "#3c403f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1946",
    d: "m521.945 385.645-.466.595-2.594-3.279a4.324 4.324 0 0 1 3.06 2.684",
    transform: "translate(-189.164 -139.612)",
    style: {
      fill: "#2c2f2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1947",
    d: "M65.172 232.945c-1.243-.6-2.511-1.162-3.725-1.819-9.116-4.934-12.931-12.35-11.69-22.674.156-1.3.211-2.614.488-3.883.414-1.892.858-3.616-1.741-4.371-1.123-.326-1.249-1.485-.825-2.481 4.237-9.943 7.56-20.281 12.912-29.744 5.156-9.119 13.339-13.432 23.33-15.085 2.614-.432 5.371-.233 7.792-1.8a2.612 2.612 0 0 0 1.489-2.457c.1-6.687.276-13.374.47-20.058a25.93 25.93 0 0 1 2.818-11.522 3.743 3.743 0 0 0 .615-1.57c-.015-2.323 1.432-3.529 3.245-4.467a18.737 18.737 0 0 1 23.683 5.31c.547.711 1.054 1.456 1.636 2.136 3.382 3.956 3.485 8.158 1.25 12.719-.628 1.282-2.668 2.628-.566 4.423.282.241-.355.766-.705.721-1.922-.247-1.857 1.176-2.169 2.386-.793 3.072-1.666 6.123-2.484 9.188a11.935 11.935 0 0 1-4.993 7.24c8.81 4.68 14.468 12.092 19.031 20.475a65.233 65.233 0 0 1 6.558 18.816c.107.546.241 1.447-.033 1.649-2.064 1.528-.773 3.276-.419 4.927.546 2.547 1.189 5.073 1.8 7.6a6.913 6.913 0 0 0 .507 1.624 5.638 5.638 0 0 0 4.069 2.843c1.207.179 1.126-1.824 1.505-2.868 2.027-5.58 3.94-11.2 5.929-16.8 1.707-4.8 4.614-6.893 9.725-6.91 10.206-.034 20.412-.006 30.618-.016 1.222 0 2.445-.071 3.666-.12 4.421-.178 6.744 2.412 5.565 6.623-1.4 5-3.1 9.926-4.737 14.859-2.666 8.022-5.448 16.005-8.042 24.05a2.954 2.954 0 0 1-3.048 2.375c-17.89 1.618-35.829 1.845-53.772 2.028q-15.3.156-30.6.293c-1.088.009-2.312.232-2.337-1.615-.015-1.107-1.165-.618-1.784-.611-8.564.084-17.127.265-25.691.328q-12.329.092-24.67-.116c4.758-.879 9.591-.694 14.4-.87.216-.366 1.183.17.923-.768",
    transform: "translate(-17.3 -39.688)",
    style: {
      fill: "#1f1f1d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1948",
    d: "M245.669 213.466c-5.385 0-10.771.037-16.155-.028a2.809 2.809 0 0 0-2.873 1.358c-.893 1.648-1.761 1.146-2.394-.1-.646-1.274-1.649-1.331-2.842-1.316-3.427.041-6.854.015-10.282.014-2.077 0-3.3-.646-3.346-3.113a84.662 84.662 0 0 1 .047-8.528c.222-2.678.97-3.464 3.862-3.466q9.913-.007 19.827.073 14.8.13 29.6.332c2.934.039 3.8.91 4.263 3.876a28.019 28.019 0 0 1-.031 7.794c-.232 1.882-1.155 2.726-3.048 2.715-5.541-.034-11.083-.012-16.624-.012v.407",
    transform: "translate(-75.715 -72.285)",
    style: {
      fill: "#1c1e1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1949",
    d: "M74.807 304.13c.313.151.986.261.769.583-.37.552-1.1.222-1.692.184l.923-.768",
    transform: "translate(-26.935 -110.873)",
    style: {
      fill: "#b2b6be"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1950",
    d: "M407.67 104.358c-6.337-.529-10.351-4.22-13.537-9.1a88.165 88.165 0 0 1-6.022-11.156c-1.824-3.923-1.354-7.555.688-11.179 4.819-8.548 15.479-12.5 23.4-8.657a19.736 19.736 0 0 1 10.133 22.253 6.946 6.946 0 0 0 .5 4.142c1.611 5.061 4.935 7.221 10.148 8.352 9.3 2.016 16.249 7.489 20.044 16.593 2.008 4.817 5.335 8.934 7.81 13.517 3.051 5.648 4.444 11.511 2.483 17.856-1.777 5.751-5.719 8.9-11.609 9.738-5.274.75-10.587.436-15.881.621-1.324.046-3.4-1-3.67 1.753-.06.607-1.153.306-1.765.31-11.1.072-22.2.147-33.294.17-13.632.028-27.265-.017-40.9.04a2.611 2.611 0 0 1-2.886-1.829c-4.743-10.794-9.61-21.534-14.444-32.288-1.694-3.769-.566-5.516 3.606-5.517q24.123-.008 48.244 0c1.036 0 2.016-.14 2.841.918 1 1.287 1.144-.359 1.34-.7a57.168 57.168 0 0 1 8.216-11.511c1.394-1.453 2.921-2.78 4.561-4.328",
    transform: "translate(-123.26 -22.894)",
    style: {
      fill: "#1f1f1d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1951",
    d: "M439.23 34.477c1.557-2.215 3.149-4.213 5.88-4.132 1.581.046 1.789 1.641 1.894 2.985 3.389-1.092 4.057-.836 5.678 2.657.471 1.014.9.262 1.319.215 2.492-.282 3.681.458 3.835 2.835.062.958.324.947 1.054 1.055 2.422.356 3.859 1.688 3.663 4.283-.062.827.215 1 .956 1.27 1.732.635 2.783 1.854 1.719 3.764-.476.854.087.851.513 1.186 2.84 2.231 2.479 5.27-.769 6.9-.337.17-1.344-.193-.782.935 1.242 2.492-.321 3.57-2.361 4.327-.753.279-1.866.168-1.263 1.615.259.621-.324 1.089-.977 1.087-.958 0-2.02.1-2.488-1.071-.661-1.652-1.763-3.138-2.023-4.936-1.3-8.985-12.678-14.037-20.858-10.531a19.009 19.009 0 0 1-2.957 1.1 2.785 2.785 0 0 1-2.91-4.53c1.229-1.033.674-1.855.276-2.917-1.285-3.432.1-5.389 3.675-5.082.981.084.821-.375.932-.909a4.828 4.828 0 0 1 1.853-3.317c1.475-.993 2.551-.686 4.141 1.214",
    transform: "translate(-155.881 -11.062)",
    style: {
      fill: "#1f1f1d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1952",
    d: "M356.269 100.473c5.542 0 11.084-.015 16.626.006 3.2.011 4.241.937 4.638 4.06a84.636 84.636 0 0 1 .283 13.176c-.083 2.863-1.036 3.883-4.072 4.1-3.245.235-6.515.243-9.77.162-1.69-.042-2.766.4-3.272 2.09a9.6 9.6 0 0 1-1 1.662c-.656 1.189-1.474 1.383-2 .046-1.181-3.02-3.488-3.2-6.279-3.137-4.143.092-8.291-.169-12.448.02-3.031.138-4.487-1.312-4.655-4.35-.219-3.981-.409-7.969-.43-11.955-.023-4.205 1.749-5.864 6-5.88 5.46-.019 10.921 0 16.382 0",
    transform: "translate(-121.723 -36.626)",
    style: {
      fill: "#1d1e1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1953",
    d: "M236.327 461.621h-.642c-3.154-.043-3.085-.034-2.659-3.214 2.066-15.438 4.075-30.884 6.143-46.321.963-7.191 2.028-14.369 3.018-21.557.219-1.59.668-2.209 2.486-1.533 4.249 1.581 4.186 1.461 3.554 6.044q-3.371 24.472-6.614 48.963c-.714 5.334-1.468 10.666-2 16.019-.281 2.81-2.171 1.345-3.281 1.6",
    transform: "translate(-84.875 -141.713)",
    style: {
      fill: "#1f1f1d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1954",
    d: "M152.738 471.606v-6.743a8.527 8.527 0 0 1 .655 6.781l-.655-.038",
    transform: "translate(-55.682 -169.47)",
    style: {
      fill: "#1b1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1955",
    d: "M110.531 528.321c.478.416.578.459.593.523.326 1.38.93 2.754.177 4.167a.757.757 0 0 1-.614-.011c-.638-1.423-.292-2.851-.156-4.679",
    transform: "translate(-40.216 -192.604)",
    style: {
      fill: "#333635"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1956",
    d: "M155.421 485.734c-.983-1.608.114-2.869.014-4.149-.009-.113.306-.343.486-.361.454-.044.494.363.469.654-.106 1.233.191 2.562-.969 3.857",
    transform: "translate(-56.51 -175.433)",
    style: {
      fill: "#2e3130"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1957",
    d: "M111.192 490.326c.172.3.333.448.308.555-.3 1.3-.229 2.735-1.254 3.785-.048.049-.545-.161-.564-.289-.228-1.6.564-2.795 1.509-4.052",
    transform: "translate(-39.972 -178.753)",
    style: {
      fill: "#252826"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1958",
    d: "M135.41 454.712c-.741 1.1-1.3 2.36-2.638 2.9-.083.034-.45-.3-.424-.392.376-1.381 1.582-2.105 2.488-3.07.492-.118.736.017.575.564",
    transform: "translate(-48.248 -165.549)",
    style: {
      fill: "#252826"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1959",
    d: "M130.323 473.364a7.5 7.5 0 0 1 .062-4.8c.808 1.978.786 3.293-.062 4.8",
    transform: "translate(-47.375 -170.821)",
    style: {
      fill: "#393d3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1960",
    d: "M125.455 490.486c.266.082.4.09.405.13a5.607 5.607 0 0 1-.468 3.639c-.023.056-.557.021-.587-.063a4.485 4.485 0 0 1 .649-3.705",
    transform: "translate(-45.432 -178.811)",
    style: {
      fill: "#262928"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1961",
    d: "M122.529 465.838c-.046 2.6-.048 2.612-.976 4.392-.548-1.541-.491-1.852.976-4.392",
    transform: "translate(-44.197 -169.826)",
    style: {
      fill: "#343837"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1962",
    d: "M101.532 519.678c.826 2.35.826 2.35.67 4.012-1.145-1.106-1.429-2.155-.67-4.012",
    transform: "translate(-36.86 -189.453)",
    style: {
      fill: "#3e4242"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1963",
    d: "M146.4 461.086c.246.962 1.136 1.879.316 2.9a.449.449 0 0 1-.425-.025 2.521 2.521 0 0 1 .109-2.872",
    transform: "translate(-53.187 -168.093)",
    style: {
      fill: "#202221"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1964",
    d: "M118.311 535.694c.621.2.854.206.9.3.482.951 1.715 1.459 1.62 2.727-.006.082-.487.259-.592.182a5.6 5.6 0 0 1-1.931-3.213",
    transform: "translate(-43.131 -195.292)",
    style: {
      fill: "#1c1e1c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1965",
    d: "M134.294 511.022c.99.745 2.231.733 2.437 1.993a.442.442 0 0 1-.673.406c-.808-.494-1.88-.828-1.764-2.4",
    transform: "translate(-48.955 -186.298)",
    style: {
      fill: "#383c3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1966",
    d: "M118.326 495.3a3.131 3.131 0 0 1 .24-3.842 5.5 5.5 0 0 1-.24 3.842",
    transform: "translate(-42.938 -179.164)",
    style: {
      fill: "#1d1e1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1967",
    d: "M148.1 480.462a3.359 3.359 0 0 1 .526 3.355.909.909 0 0 1-.574.051 4.279 4.279 0 0 1 .048-3.406",
    transform: "translate(-53.851 -175.157)",
    style: {
      fill: "#252826"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1968",
    d: "M118.469 461.478c-.621 1.569-.836 2.663-2.16 3.393-.145-1.588.609-2.367 2.16-3.393",
    transform: "translate(-42.395 -168.236)",
    style: {
      fill: "#303432"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1969",
    d: "M118.062 508.775v3.3c-1.333-1.309-1.041-2.306 0-3.3",
    transform: "translate(-42.715 -185.479)",
    style: {
      fill: "#2f3331"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1970",
    d: "m136.838 454.165-.575-.564c.282-.455.639-1.289 1.134-.884.614.5-.2 1.008-.559 1.448",
    transform: "translate(-49.676 -165.003)",
    style: {
      fill: "#383c3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1971",
    d: "M28.432 334.4c-4.082 6.863-5.655 13.722-.457 20.711-5.43-1.169-6.584-14.882.457-20.711",
    transform: "translate(-8.575 -121.909)",
    style: {
      fill: "#1c1e1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1972",
    d: "M60.021 353.956c2.988-6.924 2.177-13.512-1.479-20.469 5.369 4.167 6.107 17.685 1.479 20.469",
    transform: "translate(-21.342 -121.576)",
    style: {
      fill: "#1b1c1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1973",
    d: "M37.52 362.261a1.349 1.349 0 0 1-1.343 1.433 1.231 1.231 0 0 1-1.381-1.112 1.28 1.28 0 0 1 1.17-1.561c.9-.129 1.315.463 1.554 1.24",
    transform: "translate(-12.678 -131.607)",
    style: {
      fill: "#2d302f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1974",
    d: "M50.022 361.69a1.288 1.288 0 0 1 1.377 1.367c.014.876-.576 1.27-1.439 1.249a1.164 1.164 0 0 1-1.256-1.194 1.273 1.273 0 0 1 1.319-1.422",
    transform: "translate(-17.755 -131.857)",
    style: {
      fill: "#212422"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1975",
    d: "M43.124 361.633c.817.046 1.084.569 1.061 1.292a1.052 1.052 0 0 1-1 1.136 1.115 1.115 0 0 1-1.2-1.208c-.027-.66.276-1.262 1.138-1.219",
    transform: "translate(-15.306 -131.836)",
    style: {
      fill: "#1f211f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1976",
    d: "M553.525 260.708c-1.85.236-3.023-1.038-4.259-1.964",
    transform: "translate(-200.24 -94.328)",
    style: {
      fill: "#1b1c19"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1977",
    d: "m580.636 260.126-.5-.459",
    transform: "translate(-211.494 -94.664)",
    style: {
      fill: "#1d1e1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1978",
    d: "M291.453 49.027c-3.3 1.414-6.018-.426-6.279-3.764-.108-1.379.447-3.231-.255-4.057-1.6-1.887-1.809-3.131-.035-5.016.64-.681.173-2.357.307-3.569.282-2.567 1.555-3.745 4.182-3.492-2.442.845-2.493 2.614-2.614 4.432-.1 1.519-1.05 3.394-.809 4.4.743 3.117-.142 6.481 1.448 9.377.728 1.327 2.37 1.174 4.054 1.684",
    transform: "translate(-103.401 -10.607)",
    style: {
      fill: "#1c1e1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1979",
    d: "M315.955 48.012c3.048-1.262 2.884-2.886 2.564-5.193-.487-3.5-2.485-6.848-1.1-10.643.648-1.781-.552-3.083-2.68-3.3 1.678-1.186 3.113-.6 3.881 1.289.67 1.647.027 3.217-.2 4.8-.245 1.7-.257 3.262 1.388 4.319.352.226.862.7.623.887-1.965 1.522-.3 3.264-.367 4.88-.09 2.2-1.087 3.186-4.1 2.965",
    transform: "translate(-114.74 -10.301)",
    style: {
      fill: "#1d1e1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1980",
    d: "M310.214 56.033c-.061.736-.446 1.257-1.191 1.18s-1.008-.709-.969-1.4a.957.957 0 0 1 1.051-1.027c.779.03 1.111.5 1.109 1.245",
    transform: "translate(-112.302 -19.973)",
    style: {
      fill: "#1a1c1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1981",
    d: "M297.4 54.825c.917-.028 1.268.313 1.308 1 .043.742-.221 1.341-1.008 1.371s-1.111-.536-1.086-1.291c.021-.651.272-1.1.785-1.08",
    transform: "translate(-108.134 -19.986)",
    style: {
      fill: "#1d1e1c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1982",
    d: "M304.847 55.994c-.033.766-.42 1.272-1.2 1.206a1.057 1.057 0 0 1-.926-1.228c.018-.591.169-1.177.923-1.194.793-.018 1.186.429 1.2 1.216",
    transform: "translate(-110.36 -19.97)",
    style: {
      fill: "#1a1c1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1983",
    d: "M286.31 498.783c-2.293.84-4.728-.188-5.585 1.38-.766 1.4-.292 3.492-.325 5.279-.038 2.117.1 4.246-.088 6.347-.179 1.956.562 2.671 2.43 2.567a4.2 4.2 0 0 1 2.921.711 11.946 11.946 0 0 1-5.174.458c-1.176-.1-1.642-.909-1.628-2.039q.081-6.716.156-13.431c.008-.688.1-1.351.915-1.514a12.049 12.049 0 0 1 6.379.241",
    transform: "translate(-101.661 -181.632)",
    style: {
      fill: "#1c1e1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1984",
    d: "M307.8 515.176c.866-.348 10.792-.522 11.148-.62 4.243-1.167 4.237-1.164 4.065-5.7a64.46 64.46 0 0 1-.151-6.568c.13-2.016-.6-2.829-2.561-2.789-.614.013-10.9-.021-11.888-.93 1.941-.5 13.1-.522 14.662-.093s1.014 1.813 1.095 2.872c.28 3.648.1 7.3.073 10.948-.015 2.024-.864 2.819-2.622 2.971-1.215.1-12.063.5-13.82-.086",
    transform: "translate(-112.212 -181.612)",
    style: {
      fill: "#1b1d1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1985",
    d: "M295.335 518.119c-.812-3.327 4.287-22.393 6.344-24.369l-6.344 24.369",
    transform: "translate(-107.636 -180.001)",
    style: {
      fill: "#1c1e1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1986",
    d: "M169.036 423.633c.341-2.452 1.2-3.528 3.06-3.553.416-.006.862.177.836.668-.013.247-.324.662-.536.686-1.263.142-2.07 1.055-3.361 2.2",
    transform: "translate(-61.624 -153.144)",
    style: {
      fill: "#1f211f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1987",
    d: "M172.748 423.363c.3 1.595.838 2.624.056 3.672-.2.264-.707.337-.829.062-.513-1.158-.442-2.286.773-3.734",
    transform: "translate(-62.585 -154.341)",
    style: {
      fill: "#323534"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1988",
    d: "M469.453 353.971c1.437 3.968 3.57 5.65 6.156 4.856 2.462-.756 4-4.97 2.962-8.205-.194-.608-.509-1.176-.844-1.935 1.51 0 3.288-.538 4.1.118a12.5 12.5 0 0 1 3.311 4.672c.918 2.111-1.256 2.07-2.519 2.631a1.943 1.943 0 0 0 2.783.707 3.107 3.107 0 0 0 1.689-2.779 3.992 3.992 0 0 0-.244-1.428 2.688 2.688 0 0 1 1.137-3.2 2.014 2.014 0 0 1 2.694.15c1.089.965 1.621 2.433.792 3.5-1.23 1.581-.606 2.825-.031 4.247 1.187 2.934 2.267 5.915 3.552 8.806a2.861 2.861 0 0 1-.417 3.3c-3.268 4.385-6.954 8.415-10.433 12.619-.928 1.122-1.332.695-1.88-.262a17.458 17.458 0 0 1-1.706-4.292 3.079 3.079 0 0 1 .834-3.323c.628-.609 1.482-1.2 1.486-2.157a6.118 6.118 0 0 0-.474-3.093c-.707-1.136-1.716.092-2.567.259-5.38 1.052-9.839-1.6-11.719-7.119.788-.7 2.094-.03 2.943-1.19-1.65-.547-3.679.553-4.967-1.238a7.082 7.082 0 0 0 2.923-5.641q.216-.37.441-.006",
    transform: "translate(-169.917 -127.041)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1989",
    d: "M458.039 482.788c-10.178.318-20.326.6-30.469.985-1.78.067-1.571-1.113-1.57-2.064 0-1.611-.63-2.054-2.214-1.948-3.733.251-7.484.227-11.216.487-1.6.111-1.513-.5-1.2-1.641.888-3.259 1.547-3.776 4.729-3.225 3.072.531 5.075-1.167 7.02-3.119.6-.6.965-1.937 1.922-1.581 1.392.517 3.3.7 3.919 2.122.512 1.172 1.349 1.284 2.174 1.612a157.557 157.557 0 0 0 26.1 7.8c.3.064.658.026.809.57",
    transform: "translate(-149.902 -171.57)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1990",
    d: "m414.579 470.487 1.693-2.35c-.942-.7-1.254.131-1.688.465s-.782 1.083-1.232 1.144c-4.148.554-4.106 4.1-5.1 6.928-.041.119-.243.18-.757.537-.275-2.4-.791-4.57.976-6.416a73.7 73.7 0 0 1 9.247-7.981 5.915 5.915 0 0 1 3.65-1.228c2.28.042 4.557.214 6.836.313 1.044.046 1.54.434 1.085 1.529a8.833 8.833 0 0 0-.318.923c-1.028 3.555-1.05 3.6-4.313 2.02a2.221 2.221 0 0 0-3.014.51 28.252 28.252 0 0 1-2.975 2.887c-1.315 1.078-1.9 1.126-4.092.719",
    transform: "translate(-148.452 -168.275)",
    style: {
      fill: "#fdfdfe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1991",
    d: "M499.82 332.877a15.1 15.1 0 0 1-.032 2.442c-.1.63.627 1.911-.706 1.752-.894-.107-2.364.482-2.6-1.493a27.566 27.566 0 0 0-4.742-11.9c-.623-.943-.64-1.4.6-1.612 3.616-.633 5.318-.01 6.385 3.118a14.114 14.114 0 0 1 .684 2.589c.233 1.691.352 3.4.519 5.1l-.1.01",
    transform: "translate(-179.117 -117.33)",
    style: {
      fill: "#fdfdfe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1992",
    d: "M479.774 352.6a6.322 6.322 0 0 1-.485 3.039c-1.006 1.9-2.884 2.356-4.4.87a7.383 7.383 0 0 1-2.209-6.449 3.2 3.2 0 0 1 2.727-3.035c1.826-.318 2.941.692 3.652 2.206a6.569 6.569 0 0 1 .72 3.369",
    transform: "translate(-172.293 -126.489)",
    style: {
      fill: "#fafafc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1993",
    d: "M465.355 353.572c-.285 1.24.124 3.07-1.454 3.546-1.637.494-2.62-1.021-3.41-2.235a7.371 7.371 0 0 1-.733-6.118 2.181 2.181 0 0 1 1.875-1.7 2.229 2.229 0 0 1 2.3 1.077 10.8 10.8 0 0 1 1.427 5.427",
    transform: "translate(-167.486 -126.516)",
    style: {
      fill: "#f9fafb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1994",
    d: "M468.287 346.006a4.988 4.988 0 0 0-1.051-2.416c-2.492-3.331-2.512-3.525-.239-7.287.247.353.478.678.7 1.007 2.41 3.494 2.635 4.76 1.463 8.249-.23.272-.328.8-.877.447",
    transform: "translate(-169.639 -122.603)",
    style: {
      fill: "#f8f8fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1995",
    d: "m469.984 351.316.877-.447.012 3.974-.222-.1-.219.1-.449-3.532",
    transform: "translate(-171.337 -127.912)",
    style: {
      fill: "#6e7377"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1996",
    d: "M376.7 306.639a9.889 9.889 0 0 1 .318-1.316c.629-1.611.116-2.274-1.6-2.04a9.137 9.137 0 0 1-1.224.008c-4.815 0-5.584-.8-5.718-5.695-.125-4.562-.376-9.122-.464-13.685-.078-3.968 1.463-5.491 5.376-5.514 10.039-.06 20.078-.145 30.117-.147 4.81 0 9.615-.4 14.43-.034 3.194.243 3.908.733 4.574 3.941.688 3.311.247 6.672.335 10.009.053 2.039.1 4.088-.032 6.12-.209 3.185-1.791 4.731-5.007 4.768-10.853.125-21.707.26-32.559.172-2.8-.023-5.1.543-7.054 2.527-.376.381-.724.905-1.49.887",
    transform: "translate(-134.162 -101.37)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1997",
    d: "M148.6 200.294c-1.835 1.735-4.271 1.806-6.533 2.341-1.173.277-1.041-.792-1.226-1.394a67.568 67.568 0 0 0-2.731-8.453 2.643 2.643 0 0 0-.029 2.594 148.191 148.191 0 0 1 5.986 40.229c.06 2.926-.241 5.859-.362 8.79-.025.595-.022 1.084-.839 1.19-3.375.437-5.87 2.691-8.649 4.335a3.847 3.847 0 0 1-3.188.527c-11.694-2.884-23.2-6.393-34.663-10.074-1.425-.458-1.972-1.08-1.606-2.579.463-1.9.707-3.851 1.179-5.747.329-1.318.04-3.052 2.091-3.431.548-.1.576-.925.722-1.473 2.492-9.39 4.62-18.832 4.207-28.65a33.586 33.586 0 0 0-5.417-17.677c1.058-.236 2.032-.473 3.015-.667 1.032-.2 2.072-.37 3.343-.593-.829 3.016 1.011 5.152 2.107 7.452a45.275 45.275 0 0 0 7.228 10.395c1.2 1.354 1.7 1.133 2.188-.5.572-1.924 1.313-3.8 2.06-5.918 1.163 1.365 2.265 2.545 3.232 3.827 1.022 1.355 1.79 1.062 2.562-.188.64-1.036 1.3-2.063 2.082-3.316 1.149 2.045 2.193 3.94 3.281 5.809.27.463.329 1.223 1.039 1.232.86.011.9-.869 1.141-1.4a26.2 26.2 0 0 0 2.054-13.6c-.03-.32 0-.645 0-1.344 7.619 4.219 12.87 10.32 16.73 17.758-.234.363-.764.16-1 .523",
    transform: "translate(-34.505 -65.461)",
    style: {
      fill: "#c28f4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1998",
    d: "M136.528 283.75h-29.911c-1.2 0-2.564-.346-2.327 1.714.128 1.115-.832.965-1.55.977-9.3.164-18.653 1.032-27.882.3-10.562-.832-23.084-8-21.522-23.668.21-2.108.558-4.205.672-6.317.075-1.392.556-1.6 1.811-1.241a54.185 54.185 0 0 0 22.991 1.537c1.286-.187 1.349.238 1.111 1.284a63.411 63.411 0 0 0-1.279 6.463c-.213 1.76-.769 2.364-2.441 1.455a2.5 2.5 0 0 0-.95-.068c-.007 1.166.968 1.1 1.534 1.312a330.818 330.818 0 0 0 38.682 11.967 5.837 5.837 0 0 0 4.8-.862c1.866-1.162 3.714-2.355 5.608-3.468a2.678 2.678 0 0 1 3.862.689c2.1 2.57 4.31 5.046 6.788 7.924",
    transform: "translate(-19.396 -93.095)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1999",
    d: "M71.226 229.636a64.11 64.11 0 0 1-19.63-3.069c-1.2-.389-1.885-.705-1.291-2.176 3.686-9.118 6.762-18.5 11.545-27.143 3.436-6.207 8.123-11.2 14.87-13.927 2.691-1.087 3.68-.78 5.068 1.934a35.488 35.488 0 0 1 3.506 14.119c.6 9.569-1.432 18.8-3.714 28a1.764 1.764 0 0 1-1.755 1.557c-3.154.494-6.332.52-8.6.7",
    transform: "translate(-18.26 -66.618)",
    style: {
      fill: "#c28f4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2000",
    d: "M125.56 135.514c-1.1-.015-2.22-.412-3.388.316a32.8 32.8 0 0 1 1.336-10.189c2 2.183 3.98 4.012 5.972 5.818.878.795 1.1 1.933 2.7 1.6a1.552 1.552 0 0 1 1.736 1.336c.069 1.079-.818 1.224-1.536 1.582a4.294 4.294 0 0 0-2.549 2.751 1.253 1.253 0 0 0 .212 1.179 1.106 1.106 0 0 1 .325-.572 4.079 4.079 0 0 1 2.748-2.242 2.7 2.7 0 0 0 2.162-2.607c.1-1.482-1.018-1.916-2.034-2.419a23.326 23.326 0 0 1-8.39-6.949c-.595-.788-1.138-1.645-.17-2.281.876-.575 1.1.637 1.48 1.095 5.106 6.084 11.515 9.1 19.538 8.683 3.968-.206 5.39 1.583 4.559 5.626-.984 4.784-2.087 9.546-3.25 14.289a9.815 9.815 0 0 1-7.937 7.732 9.55 9.55 0 0 1-9.8-3.562c-.254-.306-.474-.679-.959-.655.363 3 3.353 5.047 8.776 6.014a28.827 28.827 0 0 1-5.458 11.417c-1.382-2.006-3.461-3.384-4.191-5.888-.243-.834-1.222-1.476-1.918-2.152-2.821-2.741-4.465-5.854-4.012-9.995s.53-8.3.782-12.615c1.326.419 2.479 1.707 4.238 1.136-.47-.645-1.244-.9-.618-2.08.653-1.229-.539-1.8-1.863-1.465-.435.111-.674 1.55-1.283.294a3.354 3.354 0 0 1 .217-3.49 1.353 1.353 0 0 1 1.9-.477c1.134.482 1.51 1.61 2.274 2.706.869-2.186-1.1-2.767-1.656-3.992.109-.087.2-.2.309-.283l-.248.335",
    transform: "translate(-44.271 -44.727)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2001",
    d: "M179.344 248.74c1.841.07 4.109-1.191 5.382.015 1.092 1.034 1.01 3.308 1.447 5.033s1.005 3.443 1.291 5.2c.485 2.982 1.891 5.163 4.8 6.208.982.353 1.12.852.768 1.829-1.567 4.35-3.041 8.733-4.573 13.1a1.8 1.8 0 0 1-.664.945c-1.265.717-5.672-.2-6.722-1.35-2.306-2.524-5.1-4.768-6.768-7.661-1.716-2.977-.051-6.63-.315-9.989-.3-3.81-.281-7.644-.564-11.454-.111-1.5.189-2.067 1.769-1.9a40.208 40.208 0 0 0 4.153.03",
    transform: "translate(-63.215 -90.494)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2002",
    d: "M175.632 211.888a1.022 1.022 0 0 1 1-.523c4.087 6.27 6.352 13.233 7.852 20.5.215 1.038-.266 1.326-1.108 1.381-3.489.231-6.98.416-10.465.682-1.1.084-1.443-.423-1.493-1.378a7.067 7.067 0 0 0-.147-1.21c-.516-2.225-.369-3.7 2.629-3.689a8.506 8.506 0 0 0 5.648-2.553c.314-.667.071-.768-.521-.513a17.277 17.277 0 0 1-6.932 1.976c-1 .09-1.411-.188-1.581-1.223-.483-2.949-1.059-5.884-1.665-8.81-.229-1.105.376-1.124 1.176-1.262a11.476 11.476 0 0 0 5.785-2.258c.426-.366 1.268-.97-.177-1.119",
    transform: "translate(-61.537 -77.055)",
    style: {
      fill: "#c28f4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2003",
    d: "M202.736 277.793c-.542-1.139.184-2 .492-2.851 3.984-10.991 7.919-22 11.557-33.109 1.594-4.868 3.906-6.61 9.007-6.523 10.1.17 20.192.473 30.288.722a1.037 1.037 0 0 1 .481.057c.615.371 1.968-.459 1.882.829-.061.917-1.2.566-1.869.56-3.829-.033-7.657-.159-11.486-.183-6.441-.041-12.883-.1-19.323-.014-4.283.055-5.944 1.341-7.431 5.35q-5.89 15.878-11.766 31.76a7.3 7.3 0 0 1-1.832 3.4",
    transform: "translate(-73.838 -85.783)",
    style: {
      fill: "#fcfcfd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2004",
    d: "M116.334 177.115c-.041 3.84 1.807 6.6 4.418 8.768 1.9 1.575 2.245 3.083 1.207 5.229a45.294 45.294 0 0 0-1.664 4.766 48.381 48.381 0 0 1-8.8-14.644 1.35 1.35 0 0 1 .716-1.809 16.757 16.757 0 0 1 4.125-2.311",
    transform: "translate(-40.601 -64.569)",
    style: {
      fill: "#c28f4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2005",
    d: "M148.355 197.4c-3.947-3.708-3.373-7.923-1.479-12.362a2.276 2.276 0 0 1 2.52-1.436c1.075.066.563 1.159.627 1.756a24.837 24.837 0 0 1-1.668 12.042",
    transform: "translate(-53.011 -66.932)",
    style: {
      fill: "#c28f4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2006",
    d: "M251.858 265.275c.063 2.506-1.441 4.7-2.978 4.644-2.129-.083-2.537-1.729-2.631-3.424-.111-2 1.557-4.236 3.063-4.02a2.876 2.876 0 0 1 2.546 2.8",
    transform: "translate(-89.77 -95.683)",
    style: {
      fill: "#fbfbfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2007",
    d: "M134.924 148.542a3.013 3.013 0 0 1-.675 2.251c-.382-1.2-.506-2.042.139-2.859l.537.608",
    transform: "translate(-48.826 -53.931)",
    style: {
      fill: "#45494a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2008",
    d: "M184.893 231.64a1.848 1.848 0 0 1 1.664-.918c.047.867-.5 1.179-1.142 1.43l-.522-.513",
    transform: "translate(-67.404 -84.112)",
    style: {
      fill: "#3c403f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2009",
    d: "M236.742 200.756c7.913 0 15.827-.026 23.739.012 3.393.017 3.716.309 4.225 3.655a24.777 24.777 0 0 1 .021 6.1c-.152 1.587-.914 2.166-2.563 2.169-6.115.013-12.23.186-18.344.281-4.65.072-9.3.113-13.949.173-1.132.015-2.293-.093-3.1 1.009-.2.266-.569.8-.963.37-2.277-2.5-5.308-1.383-8.02-1.671a35.44 35.44 0 0 0-5.871-.013c-1.848.114-2.426-.736-2.5-2.436-.11-2.446-.091-4.88-.023-7.327.062-2.221 1.182-2.742 3.114-2.732 8.078.039 16.156.016 24.234.016v.389",
    transform: "translate(-76.316 -73.04)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2010",
    d: "M467.706 151.651c-.435 2.809 1.321 4.939 2.18 7.524a35.711 35.711 0 0 0-14.022 1.774c-1.8.654-3.361 2.1-5.62 1.356a1.993 1.993 0 0 0-2.223 1.575c-.377 2.056-1.393 1.364-2.56.889-2.014-.822-4.043-2.091-6.274.033-1.027-6.019-1.861-11.792-2.352-17.635-1.446 6.4.547 12.7 1.13 19.037l-.654.111c-1.348-3.336-2.729-6.659-4.037-10.011a54.471 54.471 0 0 0-4.9-10.073 1.945 1.945 0 0 1-.2-2.413 116.03 116.03 0 0 1 7.287-10.7c.651-.849 1.093-1.012 1.874-.222a13.584 13.584 0 0 0 8.167 4 2.316 2.316 0 0 1 1.887 1.627c.912 1.993 2.018 3.9 2.938 5.888a1.866 1.866 0 0 0 2.15 1.109c1.057-.065 1.36-.739 1.49-1.608a25.416 25.416 0 0 0 .647-4.832c-.1-2.153 1.035-3.016 2.679-4 4.435-2.656 8.638-5.661 10.507-10.818.456-1.259 1.079-.831 1.85-.542 5.03 1.883 9.29 4.82 12.044 9.5 3.96 6.727 7.841 13.506 11.542 20.378 2.417 4.488 3.38 9.3 1.771 14.371a13.773 13.773 0 0 1-13.138 9.863c-7.507.055-15.015.031-22.523.005a5.614 5.614 0 0 1-5.667-6.092c.108-2.352.406-4.733-.173-7.06-.406-1.631.959-1.679 1.789-2.046 4.521-2 9.326-2.121 14.162-2.032.828.015 1.937.614 2.432-.362.376-.743-.437-1.482-.82-2.178a71.531 71.531 0 0 1-3.363-6.408",
    transform: "translate(-155.973 -44.988)",
    style: {
      fill: "#fbc800"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2011",
    d: "M447.871 122.64c-.815-3.479-3.638-3.87-6.4-4.493a10.281 10.281 0 0 1-4.973-3.241c1.6-1.789 3.754-2.729 5.7-3.962.432-.273 1.2-.532.919-1.183-.358-.818-1.021-.158-1.456.024-5.23 2.2-9.529.568-13.331-3.17a33.722 33.722 0 0 1-5.7-7.907c-.566-1.021-.6-1.824.448-2.5.417-.268 1.341-.266.855-1.095s-1.118-.34-1.645.067a11.589 11.589 0 0 0-.846.8c-2.73-4.081-2.666-4.73.687-7.827a12.758 12.758 0 0 1 15.752-1.826c1.118.646 1.693.675 2.631-.291 1.119-1.151 2.661-2.4 4.259-1.046 1.509 1.276 1.225 3.157.25 4.7-.775 1.226-.876 1.791.69 2.391 2.478.949 3.7 3.275 5.019 5.381a17.83 17.83 0 0 1 1.78 3.741c1.146 3.392 2.981 5.887 6.933 6 1.651.047 1.566.787.892 1.988-2.474 4.412-5.631 8.012-10.8 9.229-.97.229-1.427.6-1.379 1.6a9.22 9.22 0 0 1-.128 1.459c-.044.389-.11.777-.166 1.165",
    transform: "translate(-152.933 -30.769)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2012",
    d: "M412.8 185.4c-1.15-.031-1.068-1.059-1.348-1.733q-4.118-9.9-8.188-19.821c-1.608-3.9-2.686-4.645-6.987-4.657-7.422-.02-14.843.011-22.265-.013-3.014-.01-6.029-.082-9.041-.186-.647-.022-1.791.42-1.833-.516-.049-1.085 1.127-.585 1.738-.6 5.132-.1 10.266-.145 15.4-.2 5.46-.057 10.921-.093 16.382-.161 3.8-.046 6.462 1.334 7.864 5.178 2.532 6.94 5.359 13.771 8.029 20.66.241.621.864 1.263.248 2.046",
    transform: "translate(-132.385 -57.424)",
    style: {
      fill: "#f4f4f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2013",
    d: "M448.706 189.094c1.259.487 2.773 1.069 4.284 1.66.556.217.606.691.586 1.2a6.421 6.421 0 0 1-.016 1.218c-.4 1.624 1.212 3.7-.142 4.722-1.1.829-3.171.248-4.742.6-1.387.311-1.906-.212-2.31-1.367s-.943-2.24-1.4-3.368a3.555 3.555 0 0 1 3.739-4.669",
    transform: "translate(-162.136 -68.929)",
    style: {
      fill: "#fdfdfe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2014",
    d: "M464.614 191.9c-.158 1.855-.241 3.156-.39 4.449-.089.778.033 1.835-1.024 1.972a2.038 2.038 0 0 1-2.191-1.595 14.048 14.048 0 0 1-.41-3.623 46.271 46.271 0 0 1 .26-4.631 1.707 1.707 0 0 1 3.407-.139 12.173 12.173 0 0 1 .348 3.567",
    transform: "translate(-167.915 -68.094)",
    style: {
      fill: "#fbc800"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2015",
    d: "M458.407 146.946c-.254 1.673-.965 1.57-1.7.343a24.274 24.274 0 0 1-2.069-4.116 5.015 5.015 0 0 0-4.508-3.672 11.05 11.05 0 0 1-6.307-3.431c-.562-.556-1.019-1.028-.207-1.79.71-.666 1.123-.254 1.6.229a11.26 11.26 0 0 0 6.875 3.313c1.357.159 1.807.962 2.424 1.977 1.125 1.853 1.144 4.373 3.318 5.593 1.3.109.715.914.578 1.554",
    transform: "translate(-161.563 -48.826)",
    style: {
      fill: "#f8f8fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2016",
    d: "M466.815 142.471c-.064-.566.058-1.2-.578-1.554a25.721 25.721 0 0 0 .27-6.085c-.027-1.11.194-1.73 1.414-2.062 5.159-1.4 8.42-4.976 10.687-9.63.361-.741.523-1.974 1.8-1.276 1.181.648.087 1.441-.18 1.988-2.084 4.263-5.621 7.13-9.642 9.379-1.872 1.047-2.9 2.216-3 4.465a12.192 12.192 0 0 1-.768 4.775",
    transform: "translate(-169.971 -44.351)",
    style: {
      fill: "#f4f4f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2017",
    d: "M462.673 207.454c-3.83 0-7.662-.032-11.491.02a1.479 1.479 0 0 1-1.728-1.556c4.668-1.489 9.021-.29 13.219 1.536",
    transform: "translate(-163.853 -74.824)",
    style: {
      fill: "#f0f1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2018",
    d: "M359.289 126.187c-.858-4.178-3.764-4.141-6.8-4.076-4.161.088-8.327 0-12.49.03-2.265.017-3.4-.829-3.467-3.3-.113-4.073-.484-8.139-.35-12.219.1-3.057.948-3.965 3.951-4.031 11.256-.25 22.511-.443 33.77-.068 2.256.075 3.287 1.058 3.352 3.25.113 3.83.346 7.659.355 11.488.008 3.21-.636 3.879-3.8 4.1a76.634 76.634 0 0 1-9.043.243c-2.542-.126-3.971.843-4.655 3.2a8.212 8.212 0 0 1-.829 1.393",
    transform: "translate(-122.549 -37.298)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2019",
    d: "M481.466 369.782a5.879 5.879 0 0 0 3.671-3.425c.167-.395.151-1.118.829-.962.717.165.6.794.539 1.386a5.524 5.524 0 0 1-1.251 3.34c-1.149 1.115-2.49-.134-3.788-.339",
    transform: "translate(-175.523 -133.2)",
    style: {
      fill: "#1a1c1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2020",
    d: "M478.813 353.344c-.5-.447-.864-.743-1.191-1.077-.451-.459-1.629-.044-1.464-1.181a.881.881 0 0 1 .7-.5 2.1 2.1 0 0 1 2.018 1.054 1.319 1.319 0 0 1-.059 1.7",
    transform: "translate(-173.582 -127.811)",
    style: {
      fill: "#212422"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2021",
    d: "M476.716 355.172c1.273.966 1.042 2.106.651 3.249-.025.075-.543.119-.614.021a2.7 2.7 0 0 1-.037-3.27",
    transform: "translate(-173.597 -129.481)",
    style: {
      fill: "#3e4343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2022",
    d: "M464.457 355.488a4.686 4.686 0 0 1 1.146 2.519c.083.409-.428.615-.609.512-.935-.535-.927-1.58-1.156-2.475-.1-.388.25-.513.619-.555",
    transform: "translate(-169.09 -129.596)",
    style: {
      fill: "#343736"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2023",
    d: "M462.123 354.581c-.9-1.432-.371-2.3.515-2.863.586-.37 1.951-.719.97.777a16.51 16.51 0 0 0-1.485 2.087",
    transform: "translate(-168.301 -128.105)",
    style: {
      fill: "#272a29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2024",
    d: "M416.357 293.3c-4.166 0-8.331.015-12.5-.011-1.05-.006-2.1-.142-3.151-.226-.421-.034-.86-.153-.865-.647s.462-.559.86-.658a15.229 15.229 0 0 1 4.359.008c3.764.137 7.525.388 11.287.594q0 .471.007.941",
    transform: "translate(-145.767 -106.3)",
    style: {
      fill: "#2e3130"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2025",
    d: "M376.651 301.138a96.583 96.583 0 0 1 18.44.036c-2.582 1.184-15.975 1.219-18.44-.036",
    transform: "translate(-137.312 -109.626)",
    style: {
      fill: "#1e201e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2026",
    d: "M373.1 285.883c5.662-.87 11.326-.439 16.99.153-5.661.418-11.319 1.017-16.99-.153",
    transform: "translate(-136.017 -104.042)",
    style: {
      fill: "#232624"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2027",
    d: "M440.847 302.319c-3.417 0-6.833-.008-10.25 0-1.377 0-2.755.073-4.132.066-.439 0-1.088.168-1.2-.477-.152-.876.607-.785 1.13-.839a57.133 57.133 0 0 1 10.425.164c1.361.109 2.792-.089 4.078.44l-.052.642",
    transform: "translate(-155.027 -109.693)",
    style: {
      fill: "#1d1e1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2028",
    d: "M388.1 311.335c-4.252 0-8.5.015-12.757-.029a1.159 1.159 0 0 1-.895-.656c-.081-.421.365-.663.818-.677a62.807 62.807 0 0 1 12.8.4l.033.959",
    transform: "translate(-136.505 -112.956)",
    style: {
      fill: "#262928"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2029",
    d: "M431.936 285.881a56.46 56.46 0 0 1 12.888-.213c-1.4 1.465-10.616 1.668-12.888.213",
    transform: "translate(-157.466 -104.048)",
    style: {
      fill: "#393d3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2030",
    d: "M427.944 311.978c-3.788 0-7.576.009-11.364-.01-.527 0-1.309.118-1.316-.674-.007-.811.787-.648 1.305-.672a77.719 77.719 0 0 1 11.367.248q0 .554.008 1.108",
    transform: "translate(-151.388 -113.204)",
    style: {
      fill: "#1f211f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2031",
    d: "m418.9 287.124-7.5.468c-.642.04-1.169-.14-1.2-.862-.023-.486.389-.692.828-.694 2.619-.012 5.237-.006 7.856-.006l.015 1.095",
    transform: "translate(-149.543 -104.274)",
    style: {
      fill: "#212422"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2032",
    d: "M446.507 293.953c-2.131.18-4.261.371-6.393.532-.507.038-1.035-.1-1.058-.717-.025-.688.566-.686 1.041-.69 2.127-.014 4.254-.006 6.381-.006l.029.881",
    transform: "translate(-160.061 -106.842)",
    style: {
      fill: "#1a1c1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2033",
    d: "M380.845 292.3c-2.143.485-4.329.163-6.494.225-.4.011-.843-.079-.807-.646.026-.408.382-.506.69-.509 2.2-.018 4.409-.01 6.614-.01v.94",
    transform: "translate(-136.178 -106.219)",
    style: {
      fill: "#1e1f1c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2034",
    d: "M433.5 294.123c-.81-.1-1.192-.559-1.094-1.294.09-.665.646-.885 1.246-.839s1.092.274 1.055 1.019a1.062 1.062 0 0 1-1.207 1.115",
    transform: "translate(-157.632 -106.445)",
    style: {
      fill: "#2b2e2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2035",
    d: "M391.71 291.78a.908.908 0 0 1-1.012 1.045c-.614.019-1.144-.12-1.188-.856-.046-.763.3-1.2 1.122-1.191a.975.975 0 0 1 1.079 1",
    transform: "translate(-141.998 -106.005)",
    style: {
      fill: "#1b1c1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2036",
    d: "M405.765 310.178c-.048.838-.335 1.217-1.056 1.154a.929.929 0 0 1-.955-.874 1 1 0 0 1 .978-1.125c.767-.1.888.473 1.032.844",
    transform: "translate(-147.191 -112.766)",
    style: {
      fill: "#2b2e2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2037",
    d: "M403.575 286.752c-.665-.005-.965-.314-.942-.9.026-.647.31-1.109 1.029-1.053a.943.943 0 0 1 .923.943c.043.729-.444.966-1.01 1.012",
    transform: "translate(-146.783 -103.823)",
    style: {
      fill: "#212422"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2038",
    d: "M413.357 300.59c.7.071.914.437.856 1-.055.529-.3.954-.886.886a.886.886 0 0 1-.815-1.006.864.864 0 0 1 .844-.879",
    transform: "translate(-150.385 -109.583)",
    style: {
      fill: "#202221"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2039",
    d: "M143.179 214.533a8.855 8.855 0 0 1-2.146 1.125c-3.6.761-4.386 2.951-3.771 6.33a68.221 68.221 0 0 1 .542 7.9l3.754-1.366c-.518.7-.65 1.08-.871 1.141-3.344.923-3.171 3.625-3.093 6.2.086 2.858-.773 5.736.168 8.575.528-.241 1.03-.424 1.019.48-2.643 1.177-1.252 3.983-2.387 6.087-.774-1.169-.369-2.262-.239-3.159.223-1.542-.463-1.576-1.593-1.416-2.489.353-4.984.663-7.477.991-.477.152-.087 1.184-.954.942-.135-1.086-.967-.862-1.662-.872-2.271-.034-4.56.106-6.809-.133-2.169-.232-2.3.665-1.727 2.3a6.216 6.216 0 0 1 .176.9l-.569.086c-.32-3.8-3.427-4.021-6.12-4.776.008-.914.551-.639 1.046-.47 3.859.4 3.829.4 3.917-3.618a37.529 37.529 0 0 1 .393-5.573c.342-1.971-.381-2.806-2.264-3a12.348 12.348 0 0 1-2.1-.587c.008-.888.506-.642.991-.429 3.457.543 3.457.543 3.457-2.978 0-4.05-.023-8.1.016-12.15.01-1.025-.08-1.923-1.074-2.473-.1-.473.007-.73.553-.53.9-1.44.541-3.062.679-4.616.1-1.174-.407-2.435.8-4.061.132 2.966.36 5.419.3 7.865-.034 1.434.541 1.954 1.782 2.371a44.118 44.118 0 0 0 7.324 1.806c1.324.207 1.873-.177 1.9-1.631a55.96 55.96 0 0 1 .8-8.327c.785 2.574.259 5.193.227 7.773-.017 1.393-.093 2.016 1.673 1.917 6.255-.348 6.257-.269 5.605-6.465a13.836 13.836 0 0 1-.006-1.425l.672-.117.889 6.757 5.61-1.89c.548-.224.635.062.569.515",
    transform: "translate(-39.89 -74.874)",
    style: {
      fill: "#1b1c19"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2040",
    d: "m155.04 266.2-1.019-.48 3.569-1.961a3.136 3.136 0 0 1-2.55 2.441",
    transform: "translate(-56.15 -96.157)",
    style: {
      fill: "#2f3331"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2041",
    d: "m135.71 272.485.954-.943c-.351 1.482.337 2.941.224 5.058a6.887 6.887 0 0 1-1.179-4.115",
    transform: "translate(-49.471 -98.993)",
    style: {
      fill: "#2b2e2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2042",
    d: "m110.3 246.966-.991.429c-.946-.266-2.011-.283-2.905-1.38 1.678-.39 2.758.405 3.9.951",
    transform: "translate(-38.792 -89.649)",
    style: {
      fill: "#3a3e3d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2043",
    d: "m108.9 267.839-1.046.47a5.375 5.375 0 0 1-2.722-1.222c1.632-.462 2.666.3 3.768.752",
    transform: "translate(-38.328 -97.317)",
    style: {
      fill: "#323534"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2044",
    d: "m115.767 218.355-.553.529c-.771-.326-1.577-.608-1.915-1.492a.274.274 0 0 1 .362-.216c.97-.086 1.49.631 2.105 1.179",
    transform: "translate(-41.305 -79.17)",
    style: {
      fill: "#303432"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2045",
    d: "M112.553 216.259a.623.623 0 0 1-.362.216 3.139 3.139 0 0 1-1.936-1.822 2.237 2.237 0 0 1 2.3 1.606",
    transform: "translate(-40.194 -78.253)",
    style: {
      fill: "#2e3130"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2046",
    d: "m162.221 219.129-.569-.515c.439-.438 1.13-.933 1.5-.377s-.387.8-.926.892",
    transform: "translate(-58.932 -79.47)",
    style: {
      fill: "#434748"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2047",
    d: "M81.563 194.251c-2.335 4.191-4.547 8.441-6.5 12.831-.543 1.224-.454 1.639.9 1.977a26.3 26.3 0 0 0 9.373 1.083c-.637 1.19-1.549 1.13-2.37 1.188a18.987 18.987 0 0 1-7.466-1c-1.1-.371-1.7-.257-2.147 1.02-1.305 3.762-2.7 7.5-4.232 11.174-.558 1.343-.061 1.624 1.028 2.049a28.719 28.719 0 0 0 12.706 1.817c.539-.039 1.109-.416 1.929.308a7.073 7.073 0 0 1-4 1.144 26 26 0 0 1-11.005-1.836c-1.475-.59-1.937-.055-1.864 1.232.077 1.34.375 2.668.629 4.35a5.058 5.058 0 0 1-1.763-5.121 2.4 2.4 0 0 0-1.349-2.723 14.377 14.377 0 0 1-5.647-6.157c1.928 1.5 3.94 2.915 5.759 4.542 1.638 1.465 2.153.765 2.734-.9q1.842-5.293 3.964-10.486a1.653 1.653 0 0 0-.642-2.413c-1.237-.878-2.606-1.693-3.332-3.346 1.352.047 1.98 1.129 2.838 1.736 1.4.989 2.2 1.351 3.086-.738a58.563 58.563 0 0 1 6.829-12.334c.471-.059.721.081.545.6",
    transform: "translate(-21.794 -70.591)",
    style: {
      fill: "#1b1c19"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2048",
    d: "m93.747 193.046-.545-.6c.506-.858 1.449-2.494 1.844-2.033.9 1.043-.771 1.746-1.3 2.638",
    transform: "translate(-33.978 -69.386)",
    style: {
      fill: "#2a2d2c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2049",
    d: "M145.605 172.379c-3.179.709-5.174-.392-5.342-2.607-.037-.491-.117-1.033.465-1.257.612-.236.819.239 1.058.684 1.245 2.322 1.252 2.319 3.82 3.179",
    transform: "translate(-51.125 -61.411)",
    style: {
      fill: "#1e201e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2050",
    d: "M153.782 162.9c.087-1.423 2.307-.729 2.067-2.328a7.642 7.642 0 0 1-.131-3.97c.852 2.007 1.788 3.59 1.258 5.187a2.352 2.352 0 0 1-3.194 1.111",
    transform: "translate(-56.063 -57.092)",
    style: {
      fill: "#1c1e1c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2051",
    d: "M160.345 151.493c.381.708.53.853.517.982-.116 1.138.337 2.433-.834 3.283a.683.683 0 0 1-.6-.207 5.317 5.317 0 0 1 .915-4.058",
    transform: "translate(-58.079 -55.228)",
    style: {
      fill: "#2f3331"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2052",
    d: "M144.1 147.638a1.69 1.69 0 0 1 .961-1.844 1.746 1.746 0 0 1 2.05-.187.724.724 0 0 1 .285.59c-.214.877-1.068.508-1.612.76-.492.227-1.006.409-1.685.681",
    transform: "translate(-52.527 -52.988)",
    style: {
      fill: "#2b2e2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2053",
    d: "M146.5 149.887c.335.392.526.515.515.617-.124 1.149.47 2.467-.736 3.356a.676.676 0 0 1-.6-.214 4.3 4.3 0 0 1 .824-3.759",
    transform: "translate(-53.049 -54.643)",
    style: {
      fill: "#272a29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2054",
    d: "M161.544 148.551c-.16-1.215-1.925-.75-2.1-1.91-.085-.571.547-.691 1.077-.529a2.333 2.333 0 0 1 1.721 1.845c.074.369-.25.543-.7.594",
    transform: "translate(-58.126 -53.242)",
    style: {
      fill: "#2f3331"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2055",
    d: "M138.04 141.394c-.028.484-.282.714-.766.648a.651.651 0 0 1-.648-.578.727.727 0 0 1 .689-.808c.5-.068.65.325.724.738",
    transform: "translate(-49.807 -51.275)",
    style: {
      fill: "#3e4343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2056",
    d: "M127.876 141.965c.182-.517-.554-1.338.478-1.56a.649.649 0 0 1 .853.6c-.009.914-.816.771-1.393.909l.061.053",
    transform: "translate(-46.587 -51.178)",
    style: {
      fill: "#383c3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2057",
    d: "M129.409 135.743c.43.08.784.268.688.774a.669.669 0 0 1-.845.611 1 1 0 0 1-.559-.661c-.1-.49.272-.682.716-.724",
    transform: "translate(-46.91 -49.486)",
    style: {
      fill: "#363a39"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2058",
    d: "M125.1 137.326c.337.041.576.184.595.562.021.434-.137.815-.59.808-.207 0-.522-.33-.586-.566-.113-.414.13-.72.581-.8",
    transform: "translate(-45.386 -50.063)",
    style: {
      fill: "#414646"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2059",
    d: "M126 132.261c.417-.031.511.3.553.583a.514.514 0 0 1-.464.643c-.4.048-.55-.243-.559-.555a.59.59 0 0 1 .47-.67",
    transform: "translate(-45.765 -48.216)",
    style: {
      fill: "#1f1f1d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2060",
    d: "M242.092 212.606c5.92-.819 11.855-.374 17.788-.1a65.879 65.879 0 0 1-17.788.1",
    transform: "translate(-88.257 -77.336)",
    style: {
      fill: "#1c1e1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2061",
    d: "M264.983 206.7h-10.676c-.511 0-1.046-.043-1.051-.7a.718.718 0 0 1 .762-.769c3.659.171 7.318.36 10.976.542l-.011.921",
    transform: "translate(-92.327 -74.82)",
    style: {
      fill: "#1c1e1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2062",
    d: "M228.07 207.23c-3.707 0-7.414-.01-11.121.01-.588 0-1.217.107-1.266-.694-.03-.492.442-.637.858-.639 3.83-.011 7.662-.006 11.493-.006l.036 1.329",
    transform: "translate(-78.629 -75.062)",
    style: {
      fill: "#1d1f1d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2063",
    d: "M230.515 213.865q-4.6.2-9.209.405a.763.763 0 0 1-.89-.636.594.594 0 0 1 .595-.637 70.334 70.334 0 0 1 9.509.018q0 .424-.005.85",
    transform: "translate(-80.353 -77.594)",
    style: {
      fill: "#242725"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2064",
    d: "M285.45 206.417a48.172 48.172 0 0 1-7.357.315c-.519.007-1.107-.186-1.059-.738.057-.651.691-.83 1.3-.784 2.392.179 4.784.371 7.175.559l-.062.649",
    transform: "translate(-100.994 -74.809)",
    style: {
      fill: "#1f211f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2065",
    d: "M241.582 206.11c.081.809-.295 1.251-1.082 1.238-.668-.011-.972-.418-.985-1.1-.013-.773.227-1.241 1.092-1.188.677.041 1.052.339.975 1.05",
    transform: "translate(-87.317 -74.755)",
    style: {
      fill: "#1c1e1c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2066",
    d: "M287.627 214.972c-.681.033-1.043-.272-1.022-.972.016-.527.239-.97.791-1a1.016 1.016 0 0 1 1.191.9c.084.682-.306 1.015-.961 1.078",
    transform: "translate(-104.484 -77.649)",
    style: {
      fill: "#272a29"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2067",
    d: "M276.311 213.042c-.048.853-.468 1.125-1.106 1.115a.818.818 0 0 1-.9-.874c-.015-.631.233-1.09.936-1.108a1.006 1.006 0 0 1 1.065.868",
    transform: "translate(-100.002 -77.35)",
    style: {
      fill: "#232624"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2068",
    d: "M488.321 151.939c.055 1.89-.913 2.689-2.359 2.714a2.652 2.652 0 0 1-2.985-2.766 2.27 2.27 0 0 1 2.381-2.5 2.746 2.746 0 0 1 2.962 2.556",
    transform: "translate(-176.074 -54.459)",
    style: {
      fill: "#1c1e1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2069",
    d: "M503.294 143.093a2.577 2.577 0 0 1-2.5 2.722 2.239 2.239 0 0 1-2.375-2.508 2.411 2.411 0 0 1 2.456-2.724c1.588-.066 2.288.968 2.42 2.51",
    transform: "translate(-181.703 -51.25)",
    style: {
      fill: "#1d1e1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2070",
    d: "M515.711 173.737c-1.361-.361-2.5-.94-2.445-2.568a2.35 2.35 0 0 1 2.652-2.523 2.267 2.267 0 0 1 2.3 2.6c-.07 1.537-1.065 2.26-2.506 2.494",
    transform: "translate(-187.115 -61.48)",
    style: {
      fill: "#1c1e1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2071",
    d: "M474.681 168.159a2.506 2.506 0 0 1 2.3 2.575 1.912 1.912 0 0 1-2.2 2.012 2.218 2.218 0 0 1-2.216-2.381 2.057 2.057 0 0 1 2.12-2.206",
    transform: "translate(-172.276 -61.304)",
    style: {
      fill: "#1d1e1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2072",
    d: "M455.258 169.1c1.484.315 2.591 1.053 2.674 2.672a1.644 1.644 0 0 1-1.988 1.852 2.618 2.618 0 0 1-2.542-2.718c-.043-1.164.8-1.653 1.857-1.806",
    transform: "translate(-165.291 -61.648)",
    style: {
      fill: "#1b1d1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2073",
    d: "M502.65 157.545a2.327 2.327 0 0 1 2.177 2.163 1.693 1.693 0 0 1-1.7 1.962 2.021 2.021 0 0 1-2.2-2.084c-.069-1.191.634-1.744 1.714-2.04",
    transform: "translate(-182.619 -57.434)",
    style: {
      fill: "#1d1e1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2074",
    d: "M510.9 186.549a2.117 2.117 0 0 1-1.886 2.063 1.451 1.451 0 0 1-1.774-1.482 2.026 2.026 0 0 1 1.962-2.282c1.066-.1 1.563.629 1.7 1.7",
    transform: "translate(-184.918 -67.385)",
    style: {
      fill: "#1b1c1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2075",
    d: "M448.433 154.969a2.278 2.278 0 0 1 2.089 2.193 1.115 1.115 0 0 1-1.268 1.371 2.091 2.091 0 0 1-2.307-1.988c-.09-.994.436-1.493 1.486-1.576",
    transform: "translate(-162.935 -56.495)",
    style: {
      fill: "#1d1e1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2076",
    d: "M480.271 197.389a2.634 2.634 0 0 1 2.206 2.429c.111.628-.123 1.19-.887 1.125a2.507 2.507 0 0 1-2.446-2.534c-.076-.736.306-1.038 1.127-1.02",
    transform: "translate(-174.673 -71.96)",
    style: {
      fill: "#1c1e1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2077",
    d: "M453.587 180.782c.008 1.125-.573 1.664-1.485 1.607a1.866 1.866 0 0 1-1.965-1.732 1.315 1.315 0 0 1 1.466-1.51 2.032 2.032 0 0 1 1.984 1.634",
    transform: "translate(-164.099 -65.31)",
    style: {
      fill: "#212422"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2078",
    d: "M478.154 155.252c-.066.925-.538 1.639-1.47 1.556a1.963 1.963 0 0 1-1.983-2.018 1.237 1.237 0 0 1 1.3-1.416 2.059 2.059 0 0 1 2.155 1.878",
    transform: "translate(-173.056 -55.914)",
    style: {
      fill: "#1c1e1c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2079",
    d: "M488.222 136.32a2.11 2.11 0 0 1 1.657 1.828 1.365 1.365 0 0 1-1.518 1.516 1.8 1.8 0 0 1-1.837-1.866c.019-.907.793-1.331 1.7-1.478",
    transform: "translate(-177.367 -49.697)",
    style: {
      fill: "#1b1d1a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2080",
    d: "M477.4 187.258c1.087.157 1.791.722 1.721 1.918-.053.909-.676 1.247-1.512 1.2a1.8 1.8 0 0 1-1.754-1.951c-.03-.874.683-1.2 1.545-1.165",
    transform: "translate(-173.476 -68.266)",
    style: {
      fill: "#1c1e1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2081",
    d: "M491.084 190.18c.156-.96.646-1.4 1.514-1.281a1.545 1.545 0 0 1 1.421 1.662 1.123 1.123 0 0 1-1.2 1.228 1.8 1.8 0 0 1-1.732-1.61",
    transform: "translate(-179.029 -68.858)",
    style: {
      fill: "#202221"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2082",
    d: "M501.019 200.458c.1-.881.534-1.444 1.385-1.362a1.644 1.644 0 0 1 1.58 1.763 1.091 1.091 0 0 1-1.209 1.19 1.824 1.824 0 0 1-1.757-1.591",
    transform: "translate(-182.651 -72.579)",
    style: {
      fill: "#1d1e1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2083",
    d: "M440.823 148.21a1.685 1.685 0 0 1-1.6 1.629c-.7.088-1.354-.185-1.3-.993a1.66 1.66 0 0 1 1.556-1.549 1.167 1.167 0 0 1 1.346.913",
    transform: "translate(-159.647 -53.692)",
    style: {
      fill: "#1c1e1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2084",
    d: "M519.621 199.023c-.17.6-.528 1.053-1.177.969a1.264 1.264 0 0 1-1.194-1.51.935.935 0 0 1 1.221-.834 1.436 1.436 0 0 1 1.15 1.375",
    transform: "translate(-188.562 -72.041)",
    style: {
      fill: "#2e3130"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2085",
    d: "M436.8 92.1a7.645 7.645 0 0 1 1.387.454c.309.168.807.315.7.839-.119.606-.6.439-.954.329a2.555 2.555 0 0 0-2.064.4c-.513.28-1.089 1.135-1.585.28-.427-.737.321-1.333.935-1.706a8.862 8.862 0 0 1 1.578-.6",
    transform: "translate(-158.277 -33.577)",
    style: {
      fill: "#202221"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2086",
    d: "M442.166 116.946a3.167 3.167 0 0 0 2.122-3.5c-.048-.427.072-.858.6-.818.266.02.686.25.738.459a3.542 3.542 0 0 1-.531 3c-.6.846-1.31 1.637-2.929.864",
    transform: "translate(-161.196 -41.058)",
    style: {
      fill: "#252826"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2087",
    d: "M432.809 106.177c1.467 1.929-.973 4.745 2.333 5.734-2.706.666-2.943.537-2.809-1.622a11.05 11.05 0 0 1 .475-4.112",
    transform: "translate(-157.601 -38.708)",
    style: {
      fill: "#1d1e1c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2088",
    d: "M436.15 98.127c.635.246.874.268.907.362.383 1.068 1.624 1.86 1.063 3.218a.633.633 0 0 1-.581.069c-1-.914-1.191-2.115-1.389-3.649",
    transform: "translate(-159.002 -35.773)",
    style: {
      fill: "#333635"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2089",
    d: "M426.317 103.972c.352.164.712.226.744.364.246 1.041 1.543 1.768.93 3.041a.665.665 0 0 1-.608.039 3.669 3.669 0 0 1-1.066-3.445",
    transform: "translate(-155.381 -37.904)",
    style: {
      fill: "#232624"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2090",
    d: "M383.371 118.99h-17.187l-.025-.616c5.725-.487 11.472-.233 17.21-.313v.928",
    transform: "translate(-133.487 -43.041)",
    style: {
      fill: "#1c1e1c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2091",
    d: "M381.047 111.238H370.66c-.5 0-1.083-.052-1.06-.688.015-.4.46-.61.924-.609q5.27.01 10.54 0z",
    transform: "translate(-134.741 -40.079)",
    style: {
      fill: "#1f211f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2092",
    d: "M357.485 126.675c-3.726 0-7.452 0-11.177-.007-.375 0-.878.1-.972-.449s.346-.723.745-.714c3.809.08 7.618.192 11.427.294l-.023.876",
    transform: "translate(-125.891 -45.754)",
    style: {
      fill: "#1b1c19"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2093",
    d: "M350.183 109.677c-2.683.951-5.425.693-8.141.754-.423.01-.894-.048-.855-.586.045-.6.63-.769 1.087-.763 2.642.034 5.3-.178 7.909.6",
    transform: "translate(-124.382 -39.766)",
    style: {
      fill: "#303432"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2094",
    d: "M353.332 120.062c-2.508 0-5.016.007-7.524-.006-.5 0-1.028-.093-1.12-.695-.055-.355.252-.593.608-.608a50.208 50.208 0 0 1 8.064.225l-.028 1.083",
    transform: "translate(-125.657 -43.27)",
    style: {
      fill: "#212422"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2095",
    d: "M385.181 126.631a27.5 27.5 0 0 1-7.4.228c-.371-.05-.849-.055-.868-.632a.574.574 0 0 1 .575-.645c2.583.074 5.165.187 7.747.288l-.051.76",
    transform: "translate(-137.406 -45.782)",
    style: {
      fill: "#292c2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2096",
    d: "M362.626 110.741a.994.994 0 0 1-1.116-.956c-.072-.71.332-1 .979-1.023.535-.019.947.209.986.773.041.59-.149 1.1-.848 1.206",
    transform: "translate(-131.789 -39.65)",
    style: {
      fill: "#1e201e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2097",
    d: "M393.127 109.527a.84.84 0 0 1 .937.852c.014.581-.276 1.135-.976 1.092-.543-.033-.784-.474-.792-1a.824.824 0 0 1 .832-.941",
    transform: "translate(-143.015 -39.929)",
    style: {
      fill: "#2d302f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2098",
    d: "M130.051 232.343c0 1.791-.1 3.59.032 5.371.117 1.538-.5 1.925-1.929 2-2.765.144-6.086 1-8.07-.494-1.535-1.159-.378-4.561-.452-6.963-.081-2.605.01-5.215-.03-7.822-.019-1.232.108-1.882 1.617-1.2a23.93 23.93 0 0 0 7.787 1.906c1.2.105 1.683.5 1.476 1.847-.271 1.761-.236 3.568-.332 5.355h-.1",
    transform: "translate(-43.485 -81.281)",
    style: {
      fill: "#c28f4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2099",
    d: "M119 256.583c.283-1.92-.672-4.536.625-5.589 1.063-.864 3.565-.019 5.418.173 1.517.156 3.521-.8 4.4.334.7.893.094 2.8.067 4.262a29.5 29.5 0 0 0-.046 3.9c.277 2.4-.658 3.365-3.058 3.187-2.023-.15-4.061-.17-6.091-.134-1.31.023-1.706-.522-1.585-1.752.144-1.455.181-2.919.266-4.379",
    transform: "translate(-43.278 -91.363)",
    style: {
      fill: "#c28f4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2100",
    d: "M138.33 233.283a4.581 4.581 0 0 1 .005-.729c.342-2.1-.954-4.872.733-6.185 1.457-1.134 4.039-.793 6.11-1.183 1.014-.19 1.477-.038 1.492 1.14.042 3.33.16 6.659.318 9.986a1.579 1.579 0 0 1-1.412 1.859c-2.046.5-4.08 1.057-6.105 1.638-1.378.4-1.652-.137-1.507-1.425.189-1.69.193-3.4.278-5.1h.09",
    transform: "translate(-50.283 -82.069)",
    style: {
      fill: "#c28f4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2101",
    d: "M146.677 253.66c-.168 6.454-.168 6.454-6.49 7.238-3.1.384-3.123.383-3.043-2.657.058-2.2.313-4.4.27-6.6-.033-1.693.6-2.412 2.262-2.683a28.068 28.068 0 0 0 5.172-1.4c1.627-.6 1.963-.077 1.853 1.459s-.024 3.091-.024 4.637",
    transform: "translate(-49.99 -90.163)",
    style: {
      fill: "#c28f4c"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2199"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2198",
    style: {
      clipPath: "url(#jujzg3snxb)"
    },
    transform: "translate(223.351 107.66)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2102",
    d: "m361.1 169.523-5.77-.053a2.109 2.109 0 0 0-1.779.717 1.692 1.692 0 0 0-.089 1.755l1.453 3.415a3.572 3.572 0 0 0 1.9 1.747l11.228 3.724-9.229-.084 1.055-1.495-1.984-.658-.885 1.245a1.053 1.053 0 0 0 .053 1.164 2.744 2.744 0 0 0 2.187 1.226l9.862.09c.865.008 1.357-.522 1.148-1.231a2.465 2.465 0 0 0-1.683-1.478l-11.331-3.747a.948.948 0 0 1-.557-.487l-1.456-3.421-.421-.989 8.462.072-3.288 4.577 1.981.652 2.423-3.442.018-.031a1.454 1.454 0 0 0-.027-1.221 3.833 3.833 0 0 0-3.275-2.048",
    transform: "translate(-352.137 -169.44)",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2201"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2200",
    style: {
      clipPath: "url(#ql52paxz9c)"
    },
    transform: "translate(136.343 173.518)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2104",
    d: "m228.611 273.3-5.136.2a3.816 3.816 0 0 0-2.2.951 5.178 5.178 0 0 0-1.546 2.126l-1.547 4.071a1.769 1.769 0 0 0 .25 2.025l6.966 4-8.209.32 2.193-1.858-1.235-.7-1.827 1.552a2.862 2.862 0 0 0-.926 1.4c-.208.813.2 1.413.945 1.383l8.775-.343a2.675 2.675 0 0 0 2.057-1.542c.371-.766.255-1.466-.272-1.714l-7.05-4.016c-.152-.1-.188-.315-.093-.564l1.55-4.077.447-1.176 7.537-.3-6.771 5.69 1.235.7 5.052-4.279.036-.037a4.194 4.194 0 0 0 1-1.483c.5-1.327-.048-2.373-1.229-2.328",
    transform: "translate(-214.847 -273.148)",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2203"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2206"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 4",
    d: "M10.682 70.355A10.7 10.7 0 0 1 0 59.673V10.687A10.7 10.7 0 0 1 10.682 0h51.5a10.7 10.7 0 0 1 10.691 10.687v48.986a10.7 10.7 0 0 1-10.687 10.682z",
    transform: "translate(0 183.477)",
    style: {
      fill: "#e5f6fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 1",
    d: "M10.688 70.352A10.7 10.7 0 0 1 0 59.672V10.679A10.7 10.7 0 0 1 10.688 0h51.5a10.7 10.7 0 0 1 10.687 10.679v48.993a10.7 10.7 0 0 1-10.687 10.68z",
    transform: "translate(307.122 123.579)",
    style: {
      fill: "#e5f6fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 3",
    d: "M10.682 70.354A10.692 10.692 0 0 1 0 59.673V10.687A10.7 10.7 0 0 1 10.682 0h51.5a10.7 10.7 0 0 1 10.687 10.687v48.986a10.693 10.693 0 0 1-10.683 10.681z",
    transform: "translate(156.83)",
    style: {
      fill: "#e5f6fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 5",
    d: "M10.686 75.566A10.7 10.7 0 0 1 0 64.881v-54.2A10.7 10.7 0 0 1 10.686 0H67.6a10.7 10.7 0 0 1 10.687 10.685v54.2A10.7 10.7 0 0 1 67.6 75.566z",
    transform: "translate(156.726 281.773)",
    style: {
      fill: "#e5f6fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2114",
    d: "M309.934 531.065h-6.6a3.325 3.325 0 0 1-3.321-3.322V523.4a3.325 3.325 0 0 1 3.321-3.321h6.6a3.325 3.325 0 0 1 3.321 3.321v4.346a3.325 3.325 0 0 1-3.321 3.322m-6.6-9.012a1.345 1.345 0 0 0-1.344 1.344v4.346a1.346 1.346 0 0 0 1.344 1.345h6.6a1.346 1.346 0 0 0 1.344-1.345V523.4a1.345 1.345 0 0 0-1.344-1.344z",
    transform: "translate(-109.373 -189.597)",
    style: {
      fill: "#00848d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2115",
    d: "M312.147 517.557h-1.978v-1.3a2.043 2.043 0 1 0-4.086 0v1.3h-1.977v-1.3a4.02 4.02 0 1 1 8.041 0z",
    transform: "translate(-110.865 -186.739)",
    style: {
      fill: "#00848d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2116",
    d: "M308.848 529.9a2.763 2.763 0 1 1 2.763-2.763 2.766 2.766 0 0 1-2.763 2.763m0-3.549a.786.786 0 1 0 .785.785.786.786 0 0 0-.785-.785",
    transform: "translate(-111.586 -191.164)",
    style: {
      fill: "#00848d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2117",
    d: "M307.429 517.128h-.006v-1.977h.005a6.816 6.816 0 0 0 .005-13.632h-.005a6.852 6.852 0 0 0-4.89 2.068.989.989 0 0 1-1.66-.419 9.418 9.418 0 1 0-9.065 11.983v1.977a11.439 11.439 0 0 1-10.96-8.29 11.4 11.4 0 0 1 21.424-7.628 8.85 8.85 0 0 1 5.152-1.669h.006a8.794 8.794 0 0 1-.006 17.587",
    transform: "translate(-102.229 -180.214)",
    style: {
      fill: "#0093c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2118",
    d: "M50.041 353.812h-6.493v-1.978h6.493a2.319 2.319 0 0 0 2.316-2.317v-24.65a2.9 2.9 0 0 0-2.9-2.9H29.706a2.319 2.319 0 0 0-2.316 2.317v14.894h-1.978v-14.894a4.3 4.3 0 0 1 4.294-4.294h19.752a4.883 4.883 0 0 1 4.877 4.878v24.65a4.3 4.3 0 0 1-4.294 4.294",
    transform: "translate(-9.264 -116.654)",
    style: {
      fill: "#0093c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2119",
    d: "M53.4 352.84H28.372l.079-29.763h25.025z",
    transform: "translate(-10.343 -117.779)",
    style: {
      fill: "#e5f6fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2120",
    d: "M28.96 366.04c-4.592 0-8.458-3.423-10.353-5.463a2.531 2.531 0 0 1-.01-3.407c1.903-2.05 5.772-5.47 10.363-5.47s8.458 3.423 10.353 5.463l.01.01a2.527 2.527 0 0 1 0 3.4c-1.905 2.051-5.77 5.474-10.363 5.474m0-12.365c-3.842 0-7.228 3.027-8.9 4.831a.553.553 0 0 0 .01.736c1.667 1.793 5.053 4.82 8.895 4.82s7.228-3.027 8.9-4.831a.552.552 0 0 0-.006-.731c-1.678-1.805-5.061-4.825-8.9-4.825",
    transform: "translate(-6.542 -128.213)",
    style: {
      fill: "#0093c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2121",
    d: "M33.324 364.437a3.411 3.411 0 1 1 3.411-3.411 3.415 3.415 0 0 1-3.411 3.411m0-4.844a1.433 1.433 0 1 0 1.434 1.433 1.435 1.435 0 0 0-1.434-1.433",
    transform: "translate(-10.905 -130.37)",
    style: {
      fill: "#00848d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2122",
    d: "m38.311 341.356-4.9-4.9a.988.988 0 0 1 0-1.4l4.9-4.9 1.4 1.4-4.2 4.2 4.2 4.2z",
    transform: "translate(-12.075 -120.362)",
    style: {
      fill: "#00848d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2123",
    d: "m54.251 341.356-1.4-1.4 4.2-4.2-4.2-4.2 1.4-1.4 4.9 4.9a.988.988 0 0 1 0 1.4z",
    transform: "translate(-19.268 -120.362)",
    style: {
      fill: "#00848d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 271",
    transform: "translate(192.413 332.201)",
    style: {
      fill: "#e5f6fb"
    },
    d: "M0 0h9.699v7.433H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2124",
    d: "M309.734 525.843a1.774 1.774 0 1 1-1.774 1.774 1.774 1.774 0 0 1 1.774-1.774",
    transform: "translate(-112.27 -191.7)",
    style: {
      fill: "#00848d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2125",
    d: "M543.538 255.213h-1.249l-14.869-5.724a2.2 2.2 0 0 1-1.42-2.037v-17.944a2.182 2.182 0 0 1 .5-1.364l.067-.073a2.151 2.151 0 0 1 .9-.53l14.656-5.643a2.065 2.065 0 0 1 1.632.017l14.652 5.543a2.261 2.261 0 0 1 1.42 2.216v17.765a2.207 2.207 0 0 1-1.418 2.049zm-.882-1.977h.514l14.526-5.593a.233.233 0 0 0 .15-.217v-17.82c.006-.116-.009-.163-.04-.2l-.036-.046a.165.165 0 0 0-.072-.056L543 223.745c-.075-.031-.107-.031-.136-.018l-14.839 5.708a.173.173 0 0 0-.034.013.187.187 0 0 0-.015.073v17.918a.232.232 0 0 0 .151.2z",
    transform: "translate(-191.759 -80.835)",
    style: {
      fill: "#0093c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 272",
    transform: "translate(350.165 166.729)",
    style: {
      fill: "#0093c9"
    },
    d: "M0 0h1.977v6.832H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 273",
    transform: "rotate(-21.05 583.22 -892.588)",
    style: {
      fill: "#0093c9"
    },
    d: "M0 0h7.63v1.978H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 274",
    transform: "rotate(-68.951 276.041 -169.564)",
    style: {
      fill: "#0093c9"
    },
    d: "M0 0h1.978v6.764H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 275",
    transform: "translate(194.062 16.852)",
    style: {
      fill: "#e5f6fb"
    },
    d: "M0 0h9.699v7.433H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2126",
    d: "M311.874 33.46a2.565 2.565 0 1 1 2.565-2.564 2.568 2.568 0 0 1-2.565 2.564m0-3.548a.983.983 0 1 0 .983.984.984.984 0 0 0-.983-.984",
    transform: "translate(-112.761 -10.327)",
    style: {
      fill: "#00848d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2127",
    d: "M304.93 51.384h-15.564a4.3 4.3 0 0 1-4.3-4.3V20.359a4.306 4.306 0 0 1 4.3-4.3h5.084v1.977h-5.084a2.326 2.326 0 0 0-2.323 2.324v26.723a2.326 2.326 0 0 0 2.323 2.323h15.564a2.326 2.326 0 0 0 2.323-2.323V35.57h1.978v11.513a4.3 4.3 0 0 1-4.3 4.3",
    transform: "translate(-103.923 -5.853)",
    style: {
      fill: "#0093c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 276",
    transform: "translate(192.326 37.557)",
    style: {
      fill: "#0093c9"
    },
    d: "M0 0h3.598v1.978H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2128",
    d: "M308.518 50.527H288.2l.079-31.3H308.6z",
    transform: "translate(-105.065 -7.007)",
    style: {
      fill: "#e5f6fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 277",
    transform: "translate(190.89 37.662)",
    style: {
      fill: "#0093c9"
    },
    d: "M0 0h5.676v1.977H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2129",
    d: "M312.529 34.8h-6.6a3.325 3.325 0 0 1-3.321-3.322v-4.349a3.325 3.325 0 0 1 3.321-3.321h6.6a3.325 3.325 0 0 1 3.321 3.321v4.346a3.326 3.326 0 0 1-3.321 3.322m-6.6-9.012a1.345 1.345 0 0 0-1.344 1.343v4.346a1.346 1.346 0 0 0 1.344 1.345h6.6a1.346 1.346 0 0 0 1.344-1.345v-4.345a1.345 1.345 0 0 0-1.344-1.343z",
    transform: "translate(-110.319 -8.678)",
    style: {
      fill: "#00848d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2130",
    d: "M314.742 21.287h-1.977v-1.3a2.043 2.043 0 1 0-4.086 0v1.3H306.7v-1.3a4.02 4.02 0 1 1 8.041 0z",
    transform: "translate(-111.811 -5.82)",
    style: {
      fill: "#00848d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2131",
    d: "M311.442 33.632a2.763 2.763 0 1 1 2.758-2.762 2.765 2.765 0 0 1-2.763 2.762m0-3.548a.785.785 0 1 0 .785.785.786.786 0 0 0-.785-.785",
    transform: "translate(-112.532 -10.245)",
    style: {
      fill: "#00848d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 278",
    transform: "translate(194.062 16.852)",
    style: {
      fill: "#e5f6fb"
    },
    d: "M0 0h9.699v7.433H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2132",
    d: "M312.328 29.575a1.774 1.774 0 1 1-1.774 1.774 1.774 1.774 0 0 1 1.774-1.774",
    transform: "translate(-113.215 -10.78)",
    style: {
      fill: "#00848d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2133",
    d: "M552.317 251.764h-6.6a3.325 3.325 0 0 1-3.321-3.321V244.1a3.325 3.325 0 0 1 3.321-3.321h6.6a3.325 3.325 0 0 1 3.322 3.321v4.347a3.325 3.325 0 0 1-3.322 3.321m-6.6-9.012a1.345 1.345 0 0 0-1.343 1.344v4.347a1.345 1.345 0 0 0 1.343 1.343h6.6a1.345 1.345 0 0 0 1.343-1.343V244.1a1.345 1.345 0 0 0-1.343-1.344z",
    transform: "translate(-197.736 -87.775)",
    style: {
      fill: "#00848d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2134",
    d: "M554.53 238.255h-1.978v-1.3a2.043 2.043 0 1 0-4.086 0v1.3h-1.978v-1.3a4.02 4.02 0 1 1 8.041 0z",
    transform: "translate(-199.228 -84.917)",
    style: {
      fill: "#00848d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2135",
    d: "M551.231 250.6a2.763 2.763 0 1 1 2.763-2.763 2.766 2.766 0 0 1-2.763 2.763m0-3.548a.785.785 0 1 0 .785.785.786.786 0 0 0-.785-.785",
    transform: "translate(-199.949 -89.343)",
    style: {
      fill: "#00848d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 279",
    transform: "translate(346.434 154.722)",
    style: {
      fill: "#e5f6fb"
    },
    d: "M0 0h9.699v7.433H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2136",
    d: "M552.117 246.543a1.774 1.774 0 1 1-1.774 1.774 1.774 1.774 0 0 1 1.774-1.774",
    transform: "translate(-200.633 -89.878)",
    style: {
      fill: "#00848d"
    }
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpSkilling);
export default __webpack_public_path__ + "static/media/up-skilling.1fca56e57fadffcd777db8eb8d202606.svg";
export { ForwardRef as ReactComponent };